var map = {
	"./Boxes": 48,
	"./Boxes.svg": 48,
	"./alarm": 49,
	"./alarm-fill": 50,
	"./alarm-fill.svg": 50,
	"./alarm.svg": 49,
	"./align-bottom": 51,
	"./align-bottom.svg": 51,
	"./align-center": 52,
	"./align-center.svg": 52,
	"./align-end": 53,
	"./align-end.svg": 53,
	"./align-middle": 54,
	"./align-middle.svg": 54,
	"./align-start": 55,
	"./align-start.svg": 55,
	"./align-top": 56,
	"./align-top.svg": 56,
	"./alt": 57,
	"./alt.svg": 57,
	"./app": 58,
	"./app-indicator": 59,
	"./app-indicator.svg": 59,
	"./app.svg": 58,
	"./archive": 60,
	"./archive-fill": 61,
	"./archive-fill.svg": 61,
	"./archive.svg": 60,
	"./arrow-90deg-down": 62,
	"./arrow-90deg-down.svg": 62,
	"./arrow-90deg-left": 63,
	"./arrow-90deg-left.svg": 63,
	"./arrow-90deg-right": 64,
	"./arrow-90deg-right.svg": 64,
	"./arrow-90deg-up": 65,
	"./arrow-90deg-up.svg": 65,
	"./arrow-bar-down": 66,
	"./arrow-bar-down.svg": 66,
	"./arrow-bar-left": 67,
	"./arrow-bar-left.svg": 67,
	"./arrow-bar-right": 68,
	"./arrow-bar-right.svg": 68,
	"./arrow-bar-up": 69,
	"./arrow-bar-up.svg": 69,
	"./arrow-clockwise": 70,
	"./arrow-clockwise.svg": 70,
	"./arrow-counterclockwise": 71,
	"./arrow-counterclockwise.svg": 71,
	"./arrow-down": 72,
	"./arrow-down-circle": 73,
	"./arrow-down-circle-fill": 74,
	"./arrow-down-circle-fill.svg": 74,
	"./arrow-down-circle.svg": 73,
	"./arrow-down-left": 75,
	"./arrow-down-left-circle": 76,
	"./arrow-down-left-circle-fill": 77,
	"./arrow-down-left-circle-fill.svg": 77,
	"./arrow-down-left-circle.svg": 76,
	"./arrow-down-left-square": 78,
	"./arrow-down-left-square-fill": 79,
	"./arrow-down-left-square-fill.svg": 79,
	"./arrow-down-left-square.svg": 78,
	"./arrow-down-left.svg": 75,
	"./arrow-down-right": 80,
	"./arrow-down-right-circle": 81,
	"./arrow-down-right-circle-fill": 82,
	"./arrow-down-right-circle-fill.svg": 82,
	"./arrow-down-right-circle.svg": 81,
	"./arrow-down-right-square": 83,
	"./arrow-down-right-square-fill": 84,
	"./arrow-down-right-square-fill.svg": 84,
	"./arrow-down-right-square.svg": 83,
	"./arrow-down-right.svg": 80,
	"./arrow-down-short": 85,
	"./arrow-down-short.svg": 85,
	"./arrow-down-square": 86,
	"./arrow-down-square-fill": 87,
	"./arrow-down-square-fill.svg": 87,
	"./arrow-down-square.svg": 86,
	"./arrow-down-up": 88,
	"./arrow-down-up.svg": 88,
	"./arrow-down.svg": 72,
	"./arrow-left": 89,
	"./arrow-left-circle": 90,
	"./arrow-left-circle-fill": 91,
	"./arrow-left-circle-fill.svg": 91,
	"./arrow-left-circle.svg": 90,
	"./arrow-left-right": 92,
	"./arrow-left-right.svg": 92,
	"./arrow-left-short": 93,
	"./arrow-left-short.svg": 93,
	"./arrow-left-square": 94,
	"./arrow-left-square-fill": 95,
	"./arrow-left-square-fill.svg": 95,
	"./arrow-left-square.svg": 94,
	"./arrow-left.svg": 89,
	"./arrow-repeat": 96,
	"./arrow-repeat.svg": 96,
	"./arrow-return-left": 97,
	"./arrow-return-left.svg": 97,
	"./arrow-return-right": 98,
	"./arrow-return-right.svg": 98,
	"./arrow-right": 99,
	"./arrow-right-circle": 100,
	"./arrow-right-circle-fill": 101,
	"./arrow-right-circle-fill.svg": 101,
	"./arrow-right-circle.svg": 100,
	"./arrow-right-short": 102,
	"./arrow-right-short.svg": 102,
	"./arrow-right-square": 103,
	"./arrow-right-square-fill": 104,
	"./arrow-right-square-fill.svg": 104,
	"./arrow-right-square-warning": 105,
	"./arrow-right-square-warning.svg": 105,
	"./arrow-right-square.svg": 103,
	"./arrow-right.svg": 99,
	"./arrow-up": 106,
	"./arrow-up-circle": 107,
	"./arrow-up-circle-fill": 108,
	"./arrow-up-circle-fill.svg": 108,
	"./arrow-up-circle.svg": 107,
	"./arrow-up-left": 109,
	"./arrow-up-left-circle": 110,
	"./arrow-up-left-circle-fill": 111,
	"./arrow-up-left-circle-fill.svg": 111,
	"./arrow-up-left-circle.svg": 110,
	"./arrow-up-left-square": 112,
	"./arrow-up-left-square-fill": 113,
	"./arrow-up-left-square-fill.svg": 113,
	"./arrow-up-left-square.svg": 112,
	"./arrow-up-left.svg": 109,
	"./arrow-up-right": 114,
	"./arrow-up-right-circle": 115,
	"./arrow-up-right-circle-fill": 116,
	"./arrow-up-right-circle-fill.svg": 116,
	"./arrow-up-right-circle.svg": 115,
	"./arrow-up-right-square": 117,
	"./arrow-up-right-square-fill": 118,
	"./arrow-up-right-square-fill.svg": 118,
	"./arrow-up-right-square.svg": 117,
	"./arrow-up-right.svg": 114,
	"./arrow-up-short": 119,
	"./arrow-up-short.svg": 119,
	"./arrow-up-square": 120,
	"./arrow-up-square-fill": 121,
	"./arrow-up-square-fill.svg": 121,
	"./arrow-up-square.svg": 120,
	"./arrow-up.svg": 106,
	"./arrows-angle-contract": 122,
	"./arrows-angle-contract.svg": 122,
	"./arrows-angle-expand": 123,
	"./arrows-angle-expand.svg": 123,
	"./arrows-collapse": 124,
	"./arrows-collapse.svg": 124,
	"./arrows-expand": 125,
	"./arrows-expand.svg": 125,
	"./arrows-fullscreen": 126,
	"./arrows-fullscreen.svg": 126,
	"./arrows-move": 127,
	"./arrows-move.svg": 127,
	"./aspect-ratio": 128,
	"./aspect-ratio-fill": 129,
	"./aspect-ratio-fill.svg": 129,
	"./aspect-ratio.svg": 128,
	"./asterisk": 130,
	"./asterisk.svg": 130,
	"./at": 131,
	"./at.svg": 131,
	"./award": 132,
	"./award-fill": 133,
	"./award-fill.svg": 133,
	"./award.svg": 132,
	"./back": 134,
	"./back.svg": 134,
	"./backspace": 135,
	"./backspace-fill": 136,
	"./backspace-fill.svg": 136,
	"./backspace-reverse": 137,
	"./backspace-reverse-fill": 138,
	"./backspace-reverse-fill.svg": 138,
	"./backspace-reverse.svg": 137,
	"./backspace.svg": 135,
	"./badge-3d": 139,
	"./badge-3d-fill": 140,
	"./badge-3d-fill.svg": 140,
	"./badge-3d.svg": 139,
	"./badge-4k": 141,
	"./badge-4k-fill": 142,
	"./badge-4k-fill.svg": 142,
	"./badge-4k.svg": 141,
	"./badge-8k": 143,
	"./badge-8k-fill": 144,
	"./badge-8k-fill.svg": 144,
	"./badge-8k.svg": 143,
	"./badge-ad": 145,
	"./badge-ad-fill": 146,
	"./badge-ad-fill.svg": 146,
	"./badge-ad.svg": 145,
	"./badge-ar": 147,
	"./badge-ar-fill": 148,
	"./badge-ar-fill.svg": 148,
	"./badge-ar.svg": 147,
	"./badge-cc": 149,
	"./badge-cc-fill": 150,
	"./badge-cc-fill.svg": 150,
	"./badge-cc.svg": 149,
	"./badge-hd": 151,
	"./badge-hd-fill": 152,
	"./badge-hd-fill.svg": 152,
	"./badge-hd.svg": 151,
	"./badge-tm": 153,
	"./badge-tm-fill": 154,
	"./badge-tm-fill.svg": 154,
	"./badge-tm.svg": 153,
	"./badge-vo": 155,
	"./badge-vo-fill": 156,
	"./badge-vo-fill.svg": 156,
	"./badge-vo.svg": 155,
	"./badge-vr": 157,
	"./badge-vr-fill": 158,
	"./badge-vr-fill.svg": 158,
	"./badge-vr.svg": 157,
	"./badge-wc": 159,
	"./badge-wc-fill": 160,
	"./badge-wc-fill.svg": 160,
	"./badge-wc.svg": 159,
	"./bag": 161,
	"./bag-check": 162,
	"./bag-check-fill": 163,
	"./bag-check-fill.svg": 163,
	"./bag-check.svg": 162,
	"./bag-dash": 164,
	"./bag-dash-fill": 165,
	"./bag-dash-fill.svg": 165,
	"./bag-dash.svg": 164,
	"./bag-fill": 166,
	"./bag-fill.svg": 166,
	"./bag-plus": 167,
	"./bag-plus-fill": 168,
	"./bag-plus-fill.svg": 168,
	"./bag-plus.svg": 167,
	"./bag-x": 169,
	"./bag-x-fill": 170,
	"./bag-x-fill.svg": 170,
	"./bag-x.svg": 169,
	"./bag.svg": 161,
	"./bank": 171,
	"./bank.svg": 171,
	"./bank2": 172,
	"./bank2.svg": 172,
	"./bar-chart": 173,
	"./bar-chart-fill": 174,
	"./bar-chart-fill.svg": 174,
	"./bar-chart-line": 175,
	"./bar-chart-line-fill": 176,
	"./bar-chart-line-fill.svg": 176,
	"./bar-chart-line.svg": 175,
	"./bar-chart-steps": 177,
	"./bar-chart-steps.svg": 177,
	"./bar-chart.svg": 173,
	"./basket": 178,
	"./basket-fill": 179,
	"./basket-fill.svg": 179,
	"./basket.svg": 178,
	"./basket2": 180,
	"./basket2-fill": 181,
	"./basket2-fill.svg": 181,
	"./basket2.svg": 180,
	"./basket3": 182,
	"./basket3-fill": 183,
	"./basket3-fill.svg": 183,
	"./basket3.svg": 182,
	"./battery": 184,
	"./battery-charging": 185,
	"./battery-charging.svg": 185,
	"./battery-full": 186,
	"./battery-full.svg": 186,
	"./battery-half": 187,
	"./battery-half.svg": 187,
	"./battery.svg": 184,
	"./bell": 188,
	"./bell-fill": 189,
	"./bell-fill.svg": 189,
	"./bell-slash": 190,
	"./bell-slash-fill": 191,
	"./bell-slash-fill.svg": 191,
	"./bell-slash.svg": 190,
	"./bell.svg": 188,
	"./bezier": 192,
	"./bezier.svg": 192,
	"./bezier2": 193,
	"./bezier2.svg": 193,
	"./bicycle": 194,
	"./bicycle.svg": 194,
	"./binoculars": 195,
	"./binoculars-fill": 196,
	"./binoculars-fill.svg": 196,
	"./binoculars.svg": 195,
	"./blockquote-left": 197,
	"./blockquote-left.svg": 197,
	"./blockquote-right": 198,
	"./blockquote-right.svg": 198,
	"./book": 199,
	"./book-fill": 200,
	"./book-fill.svg": 200,
	"./book-half": 201,
	"./book-half.svg": 201,
	"./book.svg": 199,
	"./bookmark": 202,
	"./bookmark-check": 203,
	"./bookmark-check-fill": 204,
	"./bookmark-check-fill.svg": 204,
	"./bookmark-check.svg": 203,
	"./bookmark-dash": 205,
	"./bookmark-dash-fill": 206,
	"./bookmark-dash-fill.svg": 206,
	"./bookmark-dash.svg": 205,
	"./bookmark-fill": 207,
	"./bookmark-fill.svg": 207,
	"./bookmark-heart": 208,
	"./bookmark-heart-fill": 209,
	"./bookmark-heart-fill.svg": 209,
	"./bookmark-heart.svg": 208,
	"./bookmark-plus": 210,
	"./bookmark-plus-fill": 211,
	"./bookmark-plus-fill.svg": 211,
	"./bookmark-plus.svg": 210,
	"./bookmark-star": 212,
	"./bookmark-star-fill": 213,
	"./bookmark-star-fill.svg": 213,
	"./bookmark-star.svg": 212,
	"./bookmark-x": 214,
	"./bookmark-x-fill": 215,
	"./bookmark-x-fill.svg": 215,
	"./bookmark-x.svg": 214,
	"./bookmark.svg": 202,
	"./bookmarks": 216,
	"./bookmarks-fill": 217,
	"./bookmarks-fill.svg": 217,
	"./bookmarks.svg": 216,
	"./bookshelf": 218,
	"./bookshelf.svg": 218,
	"./bootstrap": 219,
	"./bootstrap-fill": 220,
	"./bootstrap-fill.svg": 220,
	"./bootstrap-icons": 2,
	"./bootstrap-icons.css": 2,
	"./bootstrap-icons.json": 1685,
	"./bootstrap-icons.svg": 1686,
	"./bootstrap-reboot": 221,
	"./bootstrap-reboot.svg": 221,
	"./bootstrap.svg": 219,
	"./border": 222,
	"./border-all": 223,
	"./border-all.svg": 223,
	"./border-bottom": 224,
	"./border-bottom.svg": 224,
	"./border-center": 225,
	"./border-center.svg": 225,
	"./border-inner": 226,
	"./border-inner.svg": 226,
	"./border-left": 227,
	"./border-left.svg": 227,
	"./border-middle": 228,
	"./border-middle.svg": 228,
	"./border-outer": 229,
	"./border-outer.svg": 229,
	"./border-right": 230,
	"./border-right.svg": 230,
	"./border-style": 231,
	"./border-style.svg": 231,
	"./border-top": 232,
	"./border-top.svg": 232,
	"./border-width": 233,
	"./border-width.svg": 233,
	"./border.svg": 222,
	"./bounding-box": 234,
	"./bounding-box-circles": 235,
	"./bounding-box-circles.svg": 235,
	"./bounding-box.svg": 234,
	"./box": 236,
	"./box-arrow-down": 237,
	"./box-arrow-down-left": 238,
	"./box-arrow-down-left.svg": 238,
	"./box-arrow-down-right": 239,
	"./box-arrow-down-right.svg": 239,
	"./box-arrow-down.svg": 237,
	"./box-arrow-in-down": 240,
	"./box-arrow-in-down-left": 241,
	"./box-arrow-in-down-left.svg": 241,
	"./box-arrow-in-down-right": 242,
	"./box-arrow-in-down-right.svg": 242,
	"./box-arrow-in-down.svg": 240,
	"./box-arrow-in-left": 243,
	"./box-arrow-in-left.svg": 243,
	"./box-arrow-in-right": 244,
	"./box-arrow-in-right.svg": 244,
	"./box-arrow-in-up": 245,
	"./box-arrow-in-up-left": 246,
	"./box-arrow-in-up-left.svg": 246,
	"./box-arrow-in-up-right": 247,
	"./box-arrow-in-up-right.svg": 247,
	"./box-arrow-in-up.svg": 245,
	"./box-arrow-left": 248,
	"./box-arrow-left.svg": 248,
	"./box-arrow-right": 249,
	"./box-arrow-right.svg": 249,
	"./box-arrow-up": 250,
	"./box-arrow-up-left": 251,
	"./box-arrow-up-left.svg": 251,
	"./box-arrow-up-right": 252,
	"./box-arrow-up-right.svg": 252,
	"./box-arrow-up.svg": 250,
	"./box-seam": 253,
	"./box-seam.svg": 253,
	"./box.svg": 236,
	"./braces": 254,
	"./braces.svg": 254,
	"./bricks": 255,
	"./bricks.svg": 255,
	"./briefcase": 256,
	"./briefcase-fill": 257,
	"./briefcase-fill.svg": 257,
	"./briefcase.svg": 256,
	"./brightness-alt-high": 258,
	"./brightness-alt-high-fill": 259,
	"./brightness-alt-high-fill.svg": 259,
	"./brightness-alt-high.svg": 258,
	"./brightness-alt-low": 260,
	"./brightness-alt-low-fill": 261,
	"./brightness-alt-low-fill.svg": 261,
	"./brightness-alt-low.svg": 260,
	"./brightness-high": 262,
	"./brightness-high-fill": 263,
	"./brightness-high-fill.svg": 263,
	"./brightness-high.svg": 262,
	"./brightness-low": 264,
	"./brightness-low-fill": 265,
	"./brightness-low-fill.svg": 265,
	"./brightness-low.svg": 264,
	"./broadcast": 266,
	"./broadcast-pin": 267,
	"./broadcast-pin.svg": 267,
	"./broadcast.svg": 266,
	"./brush": 268,
	"./brush-fill": 269,
	"./brush-fill.svg": 269,
	"./brush.svg": 268,
	"./bucket": 270,
	"./bucket-fill": 271,
	"./bucket-fill.svg": 271,
	"./bucket.svg": 270,
	"./bug": 272,
	"./bug-fill": 273,
	"./bug-fill.svg": 273,
	"./bug.svg": 272,
	"./building": 274,
	"./building.svg": 274,
	"./bullseye": 275,
	"./bullseye.svg": 275,
	"./calculator": 276,
	"./calculator-fill": 277,
	"./calculator-fill.svg": 277,
	"./calculator.svg": 276,
	"./calendar": 278,
	"./calendar-check": 279,
	"./calendar-check-fill": 280,
	"./calendar-check-fill.svg": 280,
	"./calendar-check.svg": 279,
	"./calendar-date": 281,
	"./calendar-date-fill": 282,
	"./calendar-date-fill.svg": 282,
	"./calendar-date.svg": 281,
	"./calendar-day": 283,
	"./calendar-day-fill": 284,
	"./calendar-day-fill.svg": 284,
	"./calendar-day.svg": 283,
	"./calendar-event": 285,
	"./calendar-event-fill": 286,
	"./calendar-event-fill.svg": 286,
	"./calendar-event.svg": 285,
	"./calendar-fill": 287,
	"./calendar-fill.svg": 287,
	"./calendar-minus": 288,
	"./calendar-minus-fill": 289,
	"./calendar-minus-fill.svg": 289,
	"./calendar-minus.svg": 288,
	"./calendar-month": 290,
	"./calendar-month-fill": 291,
	"./calendar-month-fill.svg": 291,
	"./calendar-month.svg": 290,
	"./calendar-plus": 292,
	"./calendar-plus-fill": 293,
	"./calendar-plus-fill.svg": 293,
	"./calendar-plus.svg": 292,
	"./calendar-range": 294,
	"./calendar-range-fill": 295,
	"./calendar-range-fill.svg": 295,
	"./calendar-range.svg": 294,
	"./calendar-week": 296,
	"./calendar-week-fill": 297,
	"./calendar-week-fill.svg": 297,
	"./calendar-week.svg": 296,
	"./calendar-x": 298,
	"./calendar-x-fill": 299,
	"./calendar-x-fill.svg": 299,
	"./calendar-x.svg": 298,
	"./calendar.svg": 278,
	"./calendar2": 300,
	"./calendar2-check": 301,
	"./calendar2-check-fill": 302,
	"./calendar2-check-fill.svg": 302,
	"./calendar2-check.svg": 301,
	"./calendar2-date": 303,
	"./calendar2-date-fill": 304,
	"./calendar2-date-fill.svg": 304,
	"./calendar2-date.svg": 303,
	"./calendar2-day": 305,
	"./calendar2-day-fill": 306,
	"./calendar2-day-fill.svg": 306,
	"./calendar2-day.svg": 305,
	"./calendar2-event": 307,
	"./calendar2-event-fill": 308,
	"./calendar2-event-fill.svg": 308,
	"./calendar2-event.svg": 307,
	"./calendar2-fill": 309,
	"./calendar2-fill.svg": 309,
	"./calendar2-minus": 310,
	"./calendar2-minus-fill": 311,
	"./calendar2-minus-fill.svg": 311,
	"./calendar2-minus.svg": 310,
	"./calendar2-month": 312,
	"./calendar2-month-fill": 313,
	"./calendar2-month-fill.svg": 313,
	"./calendar2-month.svg": 312,
	"./calendar2-plus": 314,
	"./calendar2-plus-fill": 315,
	"./calendar2-plus-fill.svg": 315,
	"./calendar2-plus.svg": 314,
	"./calendar2-range": 316,
	"./calendar2-range-fill": 317,
	"./calendar2-range-fill.svg": 317,
	"./calendar2-range.svg": 316,
	"./calendar2-week": 318,
	"./calendar2-week-fill": 319,
	"./calendar2-week-fill.svg": 319,
	"./calendar2-week.svg": 318,
	"./calendar2-x": 320,
	"./calendar2-x-fill": 321,
	"./calendar2-x-fill.svg": 321,
	"./calendar2-x.svg": 320,
	"./calendar2.svg": 300,
	"./calendar3": 322,
	"./calendar3-event": 323,
	"./calendar3-event-fill": 324,
	"./calendar3-event-fill.svg": 324,
	"./calendar3-event.svg": 323,
	"./calendar3-fill": 325,
	"./calendar3-fill.svg": 325,
	"./calendar3-range": 326,
	"./calendar3-range-fill": 327,
	"./calendar3-range-fill.svg": 327,
	"./calendar3-range.svg": 326,
	"./calendar3-week": 328,
	"./calendar3-week-fill": 329,
	"./calendar3-week-fill.svg": 329,
	"./calendar3-week.svg": 328,
	"./calendar3.svg": 322,
	"./calendar4": 330,
	"./calendar4-event": 331,
	"./calendar4-event.svg": 331,
	"./calendar4-range": 332,
	"./calendar4-range.svg": 332,
	"./calendar4-week": 333,
	"./calendar4-week.svg": 333,
	"./calendar4.svg": 330,
	"./camera": 334,
	"./camera-fill": 335,
	"./camera-fill.svg": 335,
	"./camera-reels": 336,
	"./camera-reels-fill": 337,
	"./camera-reels-fill.svg": 337,
	"./camera-reels.svg": 336,
	"./camera-video": 338,
	"./camera-video-fill": 339,
	"./camera-video-fill.svg": 339,
	"./camera-video-off": 340,
	"./camera-video-off-fill": 341,
	"./camera-video-off-fill.svg": 341,
	"./camera-video-off.svg": 340,
	"./camera-video.svg": 338,
	"./camera.svg": 334,
	"./camera2": 342,
	"./camera2.svg": 342,
	"./capslock": 343,
	"./capslock-fill": 344,
	"./capslock-fill.svg": 344,
	"./capslock.svg": 343,
	"./card-checklist": 345,
	"./card-checklist.svg": 345,
	"./card-heading": 346,
	"./card-heading.svg": 346,
	"./card-image": 347,
	"./card-image.svg": 347,
	"./card-list": 348,
	"./card-list.svg": 348,
	"./card-text": 349,
	"./card-text.svg": 349,
	"./caret-down": 350,
	"./caret-down-fill": 351,
	"./caret-down-fill.svg": 351,
	"./caret-down-square": 352,
	"./caret-down-square-fill": 353,
	"./caret-down-square-fill.svg": 353,
	"./caret-down-square.svg": 352,
	"./caret-down.svg": 350,
	"./caret-left": 354,
	"./caret-left-fill": 355,
	"./caret-left-fill.svg": 355,
	"./caret-left-square": 356,
	"./caret-left-square-fill": 357,
	"./caret-left-square-fill.svg": 357,
	"./caret-left-square.svg": 356,
	"./caret-left.svg": 354,
	"./caret-right": 358,
	"./caret-right-fill": 359,
	"./caret-right-fill.svg": 359,
	"./caret-right-square": 360,
	"./caret-right-square-fill": 361,
	"./caret-right-square-fill.svg": 361,
	"./caret-right-square.svg": 360,
	"./caret-right.svg": 358,
	"./caret-up": 362,
	"./caret-up-fill": 363,
	"./caret-up-fill.svg": 363,
	"./caret-up-square": 364,
	"./caret-up-square-fill": 365,
	"./caret-up-square-fill.svg": 365,
	"./caret-up-square.svg": 364,
	"./caret-up.svg": 362,
	"./cart": 366,
	"./cart-check": 367,
	"./cart-check-fill": 368,
	"./cart-check-fill.svg": 368,
	"./cart-check.svg": 367,
	"./cart-dash": 369,
	"./cart-dash-fill": 370,
	"./cart-dash-fill.svg": 370,
	"./cart-dash.svg": 369,
	"./cart-fill": 371,
	"./cart-fill.svg": 371,
	"./cart-plus": 372,
	"./cart-plus-fill": 373,
	"./cart-plus-fill.svg": 373,
	"./cart-plus.svg": 372,
	"./cart-x": 374,
	"./cart-x-fill": 375,
	"./cart-x-fill.svg": 375,
	"./cart-x.svg": 374,
	"./cart.svg": 366,
	"./cart2": 376,
	"./cart2.svg": 376,
	"./cart3": 377,
	"./cart3.svg": 377,
	"./cart4": 378,
	"./cart4.svg": 378,
	"./cash": 379,
	"./cash-coin": 380,
	"./cash-coin.svg": 380,
	"./cash-stack": 381,
	"./cash-stack.svg": 381,
	"./cash.svg": 379,
	"./cast": 382,
	"./cast.svg": 382,
	"./chat": 383,
	"./chat-dots": 384,
	"./chat-dots-fill": 385,
	"./chat-dots-fill.svg": 385,
	"./chat-dots.svg": 384,
	"./chat-fill": 386,
	"./chat-fill.svg": 386,
	"./chat-left": 387,
	"./chat-left-dots": 388,
	"./chat-left-dots-fill": 389,
	"./chat-left-dots-fill.svg": 389,
	"./chat-left-dots.svg": 388,
	"./chat-left-fill": 390,
	"./chat-left-fill.svg": 390,
	"./chat-left-quote": 391,
	"./chat-left-quote-fill": 392,
	"./chat-left-quote-fill.svg": 392,
	"./chat-left-quote.svg": 391,
	"./chat-left-text": 393,
	"./chat-left-text-fill": 394,
	"./chat-left-text-fill.svg": 394,
	"./chat-left-text.svg": 393,
	"./chat-left.svg": 387,
	"./chat-quote": 395,
	"./chat-quote-fill": 396,
	"./chat-quote-fill.svg": 396,
	"./chat-quote.svg": 395,
	"./chat-right": 397,
	"./chat-right-dots": 398,
	"./chat-right-dots-fill": 399,
	"./chat-right-dots-fill.svg": 399,
	"./chat-right-dots.svg": 398,
	"./chat-right-fill": 400,
	"./chat-right-fill.svg": 400,
	"./chat-right-quote": 401,
	"./chat-right-quote-fill": 402,
	"./chat-right-quote-fill.svg": 402,
	"./chat-right-quote.svg": 401,
	"./chat-right-text": 403,
	"./chat-right-text-fill": 404,
	"./chat-right-text-fill.svg": 404,
	"./chat-right-text.svg": 403,
	"./chat-right.svg": 397,
	"./chat-square": 405,
	"./chat-square-dots": 406,
	"./chat-square-dots-fill": 407,
	"./chat-square-dots-fill.svg": 407,
	"./chat-square-dots.svg": 406,
	"./chat-square-fill": 408,
	"./chat-square-fill.svg": 408,
	"./chat-square-quote": 409,
	"./chat-square-quote-fill": 410,
	"./chat-square-quote-fill.svg": 410,
	"./chat-square-quote.svg": 409,
	"./chat-square-text": 411,
	"./chat-square-text-fill": 412,
	"./chat-square-text-fill.svg": 412,
	"./chat-square-text.svg": 411,
	"./chat-square.svg": 405,
	"./chat-text": 413,
	"./chat-text-fill": 414,
	"./chat-text-fill.svg": 414,
	"./chat-text.svg": 413,
	"./chat.svg": 383,
	"./check": 415,
	"./check-all": 416,
	"./check-all.svg": 416,
	"./check-circle": 417,
	"./check-circle-fill": 418,
	"./check-circle-fill.svg": 418,
	"./check-circle.svg": 417,
	"./check-lg": 419,
	"./check-lg.svg": 419,
	"./check-square": 420,
	"./check-square-fill": 421,
	"./check-square-fill.svg": 421,
	"./check-square.svg": 420,
	"./check.svg": 415,
	"./check2": 422,
	"./check2-all": 423,
	"./check2-all.svg": 423,
	"./check2-circle": 424,
	"./check2-circle.svg": 424,
	"./check2-square": 425,
	"./check2-square.svg": 425,
	"./check2.svg": 422,
	"./chevron-bar-contract": 426,
	"./chevron-bar-contract.svg": 426,
	"./chevron-bar-down": 427,
	"./chevron-bar-down.svg": 427,
	"./chevron-bar-expand": 428,
	"./chevron-bar-expand.svg": 428,
	"./chevron-bar-left": 429,
	"./chevron-bar-left.svg": 429,
	"./chevron-bar-right": 430,
	"./chevron-bar-right.svg": 430,
	"./chevron-bar-up": 431,
	"./chevron-bar-up.svg": 431,
	"./chevron-compact-down": 432,
	"./chevron-compact-down.svg": 432,
	"./chevron-compact-left": 433,
	"./chevron-compact-left.svg": 433,
	"./chevron-compact-right": 434,
	"./chevron-compact-right.svg": 434,
	"./chevron-compact-up": 435,
	"./chevron-compact-up.svg": 435,
	"./chevron-contract": 436,
	"./chevron-contract.svg": 436,
	"./chevron-double-down": 437,
	"./chevron-double-down.svg": 437,
	"./chevron-double-left": 438,
	"./chevron-double-left.svg": 438,
	"./chevron-double-right": 439,
	"./chevron-double-right.svg": 439,
	"./chevron-double-up": 440,
	"./chevron-double-up.svg": 440,
	"./chevron-down": 441,
	"./chevron-down.svg": 441,
	"./chevron-expand": 442,
	"./chevron-expand.svg": 442,
	"./chevron-left": 443,
	"./chevron-left.svg": 443,
	"./chevron-right": 444,
	"./chevron-right.svg": 444,
	"./chevron-up": 445,
	"./chevron-up.svg": 445,
	"./circle": 446,
	"./circle-fill": 447,
	"./circle-fill.svg": 447,
	"./circle-half": 448,
	"./circle-half.svg": 448,
	"./circle-square": 449,
	"./circle-square.svg": 449,
	"./circle.svg": 446,
	"./clipboard": 450,
	"./clipboard-check": 451,
	"./clipboard-check.svg": 451,
	"./clipboard-data": 452,
	"./clipboard-data.svg": 452,
	"./clipboard-minus": 453,
	"./clipboard-minus.svg": 453,
	"./clipboard-plus": 454,
	"./clipboard-plus.svg": 454,
	"./clipboard-x": 455,
	"./clipboard-x.svg": 455,
	"./clipboard.svg": 450,
	"./clock": 456,
	"./clock-fill": 457,
	"./clock-fill.svg": 457,
	"./clock-history": 458,
	"./clock-history.svg": 458,
	"./clock.svg": 456,
	"./cloud": 459,
	"./cloud-arrow-down": 460,
	"./cloud-arrow-down-fill": 461,
	"./cloud-arrow-down-fill.svg": 461,
	"./cloud-arrow-down.svg": 460,
	"./cloud-arrow-up": 462,
	"./cloud-arrow-up-fill": 463,
	"./cloud-arrow-up-fill.svg": 463,
	"./cloud-arrow-up.svg": 462,
	"./cloud-check": 464,
	"./cloud-check-fill": 465,
	"./cloud-check-fill.svg": 465,
	"./cloud-check.svg": 464,
	"./cloud-download": 466,
	"./cloud-download-fill": 467,
	"./cloud-download-fill.svg": 467,
	"./cloud-download.svg": 466,
	"./cloud-drizzle": 468,
	"./cloud-drizzle-fill": 469,
	"./cloud-drizzle-fill.svg": 469,
	"./cloud-drizzle.svg": 468,
	"./cloud-fill": 470,
	"./cloud-fill.svg": 470,
	"./cloud-fog": 471,
	"./cloud-fog-fill": 472,
	"./cloud-fog-fill.svg": 472,
	"./cloud-fog.svg": 471,
	"./cloud-fog2": 473,
	"./cloud-fog2-fill": 474,
	"./cloud-fog2-fill.svg": 474,
	"./cloud-fog2.svg": 473,
	"./cloud-hail": 475,
	"./cloud-hail-fill": 476,
	"./cloud-hail-fill.svg": 476,
	"./cloud-hail.svg": 475,
	"./cloud-haze": 477,
	"./cloud-haze-1": 478,
	"./cloud-haze-1.svg": 478,
	"./cloud-haze-fill": 479,
	"./cloud-haze-fill.svg": 479,
	"./cloud-haze.svg": 477,
	"./cloud-haze2-fill": 480,
	"./cloud-haze2-fill.svg": 480,
	"./cloud-lightning": 481,
	"./cloud-lightning-fill": 482,
	"./cloud-lightning-fill.svg": 482,
	"./cloud-lightning-rain": 483,
	"./cloud-lightning-rain-fill": 484,
	"./cloud-lightning-rain-fill.svg": 484,
	"./cloud-lightning-rain.svg": 483,
	"./cloud-lightning.svg": 481,
	"./cloud-minus": 485,
	"./cloud-minus-fill": 486,
	"./cloud-minus-fill.svg": 486,
	"./cloud-minus.svg": 485,
	"./cloud-moon": 487,
	"./cloud-moon-fill": 488,
	"./cloud-moon-fill.svg": 488,
	"./cloud-moon.svg": 487,
	"./cloud-plus": 489,
	"./cloud-plus-fill": 490,
	"./cloud-plus-fill.svg": 490,
	"./cloud-plus.svg": 489,
	"./cloud-rain": 491,
	"./cloud-rain-fill": 492,
	"./cloud-rain-fill.svg": 492,
	"./cloud-rain-heavy": 493,
	"./cloud-rain-heavy-fill": 494,
	"./cloud-rain-heavy-fill.svg": 494,
	"./cloud-rain-heavy.svg": 493,
	"./cloud-rain.svg": 491,
	"./cloud-slash": 495,
	"./cloud-slash-fill": 496,
	"./cloud-slash-fill.svg": 496,
	"./cloud-slash.svg": 495,
	"./cloud-sleet": 497,
	"./cloud-sleet-fill": 498,
	"./cloud-sleet-fill.svg": 498,
	"./cloud-sleet.svg": 497,
	"./cloud-snow": 499,
	"./cloud-snow-fill": 500,
	"./cloud-snow-fill.svg": 500,
	"./cloud-snow.svg": 499,
	"./cloud-sun": 501,
	"./cloud-sun-fill": 502,
	"./cloud-sun-fill.svg": 502,
	"./cloud-sun.svg": 501,
	"./cloud-upload": 503,
	"./cloud-upload-fill": 504,
	"./cloud-upload-fill.svg": 504,
	"./cloud-upload.svg": 503,
	"./cloud.svg": 459,
	"./clouds": 505,
	"./clouds-fill": 506,
	"./clouds-fill.svg": 506,
	"./clouds.svg": 505,
	"./cloudy": 507,
	"./cloudy-fill": 508,
	"./cloudy-fill.svg": 508,
	"./cloudy.svg": 507,
	"./code": 509,
	"./code-slash": 510,
	"./code-slash.svg": 510,
	"./code-square": 511,
	"./code-square.svg": 511,
	"./code.svg": 509,
	"./coin": 512,
	"./coin.svg": 512,
	"./collection": 513,
	"./collection-fill": 514,
	"./collection-fill.svg": 514,
	"./collection-play": 515,
	"./collection-play-fill": 516,
	"./collection-play-fill.svg": 516,
	"./collection-play.svg": 515,
	"./collection.svg": 513,
	"./columns": 517,
	"./columns-gap": 518,
	"./columns-gap.svg": 518,
	"./columns.svg": 517,
	"./command": 519,
	"./command.svg": 519,
	"./compass": 520,
	"./compass-fill": 521,
	"./compass-fill.svg": 521,
	"./compass.svg": 520,
	"./cone": 522,
	"./cone-striped": 523,
	"./cone-striped.svg": 523,
	"./cone.svg": 522,
	"./controller": 524,
	"./controller.svg": 524,
	"./cpu": 525,
	"./cpu-fill": 526,
	"./cpu-fill.svg": 526,
	"./cpu.svg": 525,
	"./credit-card": 527,
	"./credit-card-2-back": 528,
	"./credit-card-2-back-fill": 529,
	"./credit-card-2-back-fill.svg": 529,
	"./credit-card-2-back.svg": 528,
	"./credit-card-2-front": 530,
	"./credit-card-2-front-fill": 531,
	"./credit-card-2-front-fill.svg": 531,
	"./credit-card-2-front.svg": 530,
	"./credit-card-fill": 532,
	"./credit-card-fill.svg": 532,
	"./credit-card.svg": 527,
	"./crop": 533,
	"./crop.svg": 533,
	"./cup": 534,
	"./cup-fill": 535,
	"./cup-fill.svg": 535,
	"./cup-straw": 536,
	"./cup-straw.svg": 536,
	"./cup.svg": 534,
	"./currency-bitcoin": 537,
	"./currency-bitcoin.svg": 537,
	"./currency-dollar": 538,
	"./currency-dollar.svg": 538,
	"./currency-euro": 539,
	"./currency-euro.svg": 539,
	"./currency-exchange": 540,
	"./currency-exchange.svg": 540,
	"./currency-pound": 541,
	"./currency-pound.svg": 541,
	"./currency-yen": 542,
	"./currency-yen.svg": 542,
	"./cursor": 543,
	"./cursor-fill": 544,
	"./cursor-fill.svg": 544,
	"./cursor-text": 545,
	"./cursor-text.svg": 545,
	"./cursor.svg": 543,
	"./dash": 546,
	"./dash-circle": 547,
	"./dash-circle-dotted": 548,
	"./dash-circle-dotted.svg": 548,
	"./dash-circle-fill": 549,
	"./dash-circle-fill.svg": 549,
	"./dash-circle.svg": 547,
	"./dash-lg": 550,
	"./dash-lg.svg": 550,
	"./dash-square": 551,
	"./dash-square-dotted": 552,
	"./dash-square-dotted.svg": 552,
	"./dash-square-fill": 553,
	"./dash-square-fill.svg": 553,
	"./dash-square.svg": 551,
	"./dash.svg": 546,
	"./diagram-2": 554,
	"./diagram-2-fill": 555,
	"./diagram-2-fill.svg": 555,
	"./diagram-2.svg": 554,
	"./diagram-3": 556,
	"./diagram-3-fill": 557,
	"./diagram-3-fill.svg": 557,
	"./diagram-3.svg": 556,
	"./diamond": 558,
	"./diamond-fill": 559,
	"./diamond-fill.svg": 559,
	"./diamond-half": 560,
	"./diamond-half.svg": 560,
	"./diamond.svg": 558,
	"./dice-1": 561,
	"./dice-1-fill": 562,
	"./dice-1-fill.svg": 562,
	"./dice-1.svg": 561,
	"./dice-2": 563,
	"./dice-2-fill": 564,
	"./dice-2-fill.svg": 564,
	"./dice-2.svg": 563,
	"./dice-3": 565,
	"./dice-3-fill": 566,
	"./dice-3-fill.svg": 566,
	"./dice-3.svg": 565,
	"./dice-4": 567,
	"./dice-4-fill": 568,
	"./dice-4-fill.svg": 568,
	"./dice-4.svg": 567,
	"./dice-5": 569,
	"./dice-5-fill": 570,
	"./dice-5-fill.svg": 570,
	"./dice-5.svg": 569,
	"./dice-6": 571,
	"./dice-6-fill": 572,
	"./dice-6-fill.svg": 572,
	"./dice-6.svg": 571,
	"./disc": 573,
	"./disc-fill": 574,
	"./disc-fill.svg": 574,
	"./disc.svg": 573,
	"./discord": 575,
	"./discord.svg": 575,
	"./display": 576,
	"./display-fill": 577,
	"./display-fill.svg": 577,
	"./display.svg": 576,
	"./distribute-horizontal": 578,
	"./distribute-horizontal.svg": 578,
	"./distribute-vertical": 579,
	"./distribute-vertical.svg": 579,
	"./door-closed": 580,
	"./door-closed-fill": 581,
	"./door-closed-fill.svg": 581,
	"./door-closed.svg": 580,
	"./door-open": 582,
	"./door-open-fill": 583,
	"./door-open-fill.svg": 583,
	"./door-open.svg": 582,
	"./dot": 584,
	"./dot.svg": 584,
	"./download": 585,
	"./download.svg": 585,
	"./droplet": 586,
	"./droplet-fill": 587,
	"./droplet-fill.svg": 587,
	"./droplet-half": 588,
	"./droplet-half.svg": 588,
	"./droplet.svg": 586,
	"./earbuds": 589,
	"./earbuds.svg": 589,
	"./easel": 590,
	"./easel-fill": 591,
	"./easel-fill.svg": 591,
	"./easel.svg": 590,
	"./egg": 592,
	"./egg-fill": 593,
	"./egg-fill.svg": 593,
	"./egg-fried": 594,
	"./egg-fried.svg": 594,
	"./egg.svg": 592,
	"./eject": 595,
	"./eject-fill": 596,
	"./eject-fill.svg": 596,
	"./eject.svg": 595,
	"./emoji-angry": 597,
	"./emoji-angry-fill": 598,
	"./emoji-angry-fill.svg": 598,
	"./emoji-angry.svg": 597,
	"./emoji-dizzy": 599,
	"./emoji-dizzy-fill": 600,
	"./emoji-dizzy-fill.svg": 600,
	"./emoji-dizzy.svg": 599,
	"./emoji-expressionless": 601,
	"./emoji-expressionless-fill": 602,
	"./emoji-expressionless-fill.svg": 602,
	"./emoji-expressionless.svg": 601,
	"./emoji-frown": 603,
	"./emoji-frown-fill": 604,
	"./emoji-frown-fill.svg": 604,
	"./emoji-frown.svg": 603,
	"./emoji-heart-eyes": 605,
	"./emoji-heart-eyes-fill": 606,
	"./emoji-heart-eyes-fill.svg": 606,
	"./emoji-heart-eyes.svg": 605,
	"./emoji-laughing": 607,
	"./emoji-laughing-fill": 608,
	"./emoji-laughing-fill.svg": 608,
	"./emoji-laughing.svg": 607,
	"./emoji-neutral": 609,
	"./emoji-neutral-fill": 610,
	"./emoji-neutral-fill.svg": 610,
	"./emoji-neutral.svg": 609,
	"./emoji-smile": 611,
	"./emoji-smile-fill": 612,
	"./emoji-smile-fill.svg": 612,
	"./emoji-smile-upside-down": 613,
	"./emoji-smile-upside-down-fill": 614,
	"./emoji-smile-upside-down-fill.svg": 614,
	"./emoji-smile-upside-down.svg": 613,
	"./emoji-smile.svg": 611,
	"./emoji-sunglasses": 615,
	"./emoji-sunglasses-fill": 616,
	"./emoji-sunglasses-fill.svg": 616,
	"./emoji-sunglasses.svg": 615,
	"./emoji-wink": 617,
	"./emoji-wink-fill": 618,
	"./emoji-wink-fill.svg": 618,
	"./emoji-wink.svg": 617,
	"./envelope": 619,
	"./envelope-fill": 620,
	"./envelope-fill.svg": 620,
	"./envelope-open": 621,
	"./envelope-open-fill": 622,
	"./envelope-open-fill.svg": 622,
	"./envelope-open.svg": 621,
	"./envelope.svg": 619,
	"./eraser": 623,
	"./eraser-fill": 624,
	"./eraser-fill.svg": 624,
	"./eraser.svg": 623,
	"./exclamation": 625,
	"./exclamation-circle": 626,
	"./exclamation-circle-fill": 627,
	"./exclamation-circle-fill.svg": 627,
	"./exclamation-circle.svg": 626,
	"./exclamation-diamond": 628,
	"./exclamation-diamond-fill": 629,
	"./exclamation-diamond-fill.svg": 629,
	"./exclamation-diamond.svg": 628,
	"./exclamation-lg": 630,
	"./exclamation-lg.svg": 630,
	"./exclamation-octagon": 631,
	"./exclamation-octagon-fill": 632,
	"./exclamation-octagon-fill.svg": 632,
	"./exclamation-octagon.svg": 631,
	"./exclamation-square": 633,
	"./exclamation-square-fill": 634,
	"./exclamation-square-fill.svg": 634,
	"./exclamation-square.svg": 633,
	"./exclamation-triangle": 635,
	"./exclamation-triangle-fill": 636,
	"./exclamation-triangle-fill.svg": 636,
	"./exclamation-triangle.svg": 635,
	"./exclamation.svg": 625,
	"./exclude": 637,
	"./exclude.svg": 637,
	"./eye": 638,
	"./eye-fill": 639,
	"./eye-fill.svg": 639,
	"./eye-slash": 640,
	"./eye-slash-fill": 641,
	"./eye-slash-fill.svg": 641,
	"./eye-slash.svg": 640,
	"./eye.svg": 638,
	"./eyedropper": 642,
	"./eyedropper.svg": 642,
	"./eyeglasses": 643,
	"./eyeglasses.svg": 643,
	"./facebook": 644,
	"./facebook.svg": 644,
	"./file": 645,
	"./file-arrow-down": 646,
	"./file-arrow-down-fill": 647,
	"./file-arrow-down-fill.svg": 647,
	"./file-arrow-down.svg": 646,
	"./file-arrow-up": 648,
	"./file-arrow-up-fill": 649,
	"./file-arrow-up-fill.svg": 649,
	"./file-arrow-up.svg": 648,
	"./file-bar-graph": 650,
	"./file-bar-graph-fill": 651,
	"./file-bar-graph-fill.svg": 651,
	"./file-bar-graph.svg": 650,
	"./file-binary": 652,
	"./file-binary-fill": 653,
	"./file-binary-fill.svg": 653,
	"./file-binary.svg": 652,
	"./file-break": 654,
	"./file-break-fill": 655,
	"./file-break-fill.svg": 655,
	"./file-break.svg": 654,
	"./file-check": 656,
	"./file-check-fill": 657,
	"./file-check-fill.svg": 657,
	"./file-check.svg": 656,
	"./file-code": 658,
	"./file-code-fill": 659,
	"./file-code-fill.svg": 659,
	"./file-code.svg": 658,
	"./file-diff": 660,
	"./file-diff-fill": 661,
	"./file-diff-fill.svg": 661,
	"./file-diff.svg": 660,
	"./file-earmark": 662,
	"./file-earmark-arrow-down": 663,
	"./file-earmark-arrow-down-fill": 664,
	"./file-earmark-arrow-down-fill.svg": 664,
	"./file-earmark-arrow-down.svg": 663,
	"./file-earmark-arrow-up": 665,
	"./file-earmark-arrow-up-fill": 666,
	"./file-earmark-arrow-up-fill.svg": 666,
	"./file-earmark-arrow-up.svg": 665,
	"./file-earmark-bar-graph": 667,
	"./file-earmark-bar-graph-fill": 668,
	"./file-earmark-bar-graph-fill.svg": 668,
	"./file-earmark-bar-graph.svg": 667,
	"./file-earmark-binary": 669,
	"./file-earmark-binary-fill": 670,
	"./file-earmark-binary-fill.svg": 670,
	"./file-earmark-binary.svg": 669,
	"./file-earmark-break": 671,
	"./file-earmark-break-fill": 672,
	"./file-earmark-break-fill.svg": 672,
	"./file-earmark-break.svg": 671,
	"./file-earmark-check": 673,
	"./file-earmark-check-fill": 674,
	"./file-earmark-check-fill.svg": 674,
	"./file-earmark-check.svg": 673,
	"./file-earmark-code": 675,
	"./file-earmark-code-fill": 676,
	"./file-earmark-code-fill.svg": 676,
	"./file-earmark-code.svg": 675,
	"./file-earmark-diff": 677,
	"./file-earmark-diff-fill": 678,
	"./file-earmark-diff-fill.svg": 678,
	"./file-earmark-diff.svg": 677,
	"./file-earmark-easel": 679,
	"./file-earmark-easel-fill": 680,
	"./file-earmark-easel-fill.svg": 680,
	"./file-earmark-easel.svg": 679,
	"./file-earmark-excel": 681,
	"./file-earmark-excel-fill": 682,
	"./file-earmark-excel-fill.svg": 682,
	"./file-earmark-excel.svg": 681,
	"./file-earmark-fill": 683,
	"./file-earmark-fill.svg": 683,
	"./file-earmark-font": 684,
	"./file-earmark-font-fill": 685,
	"./file-earmark-font-fill.svg": 685,
	"./file-earmark-font.svg": 684,
	"./file-earmark-image": 686,
	"./file-earmark-image-fill": 687,
	"./file-earmark-image-fill.svg": 687,
	"./file-earmark-image.svg": 686,
	"./file-earmark-lock": 688,
	"./file-earmark-lock-fill": 689,
	"./file-earmark-lock-fill.svg": 689,
	"./file-earmark-lock.svg": 688,
	"./file-earmark-lock2": 690,
	"./file-earmark-lock2-fill": 691,
	"./file-earmark-lock2-fill.svg": 691,
	"./file-earmark-lock2.svg": 690,
	"./file-earmark-medical": 692,
	"./file-earmark-medical-fill": 693,
	"./file-earmark-medical-fill.svg": 693,
	"./file-earmark-medical.svg": 692,
	"./file-earmark-minus": 694,
	"./file-earmark-minus-fill": 695,
	"./file-earmark-minus-fill.svg": 695,
	"./file-earmark-minus.svg": 694,
	"./file-earmark-music": 696,
	"./file-earmark-music-fill": 697,
	"./file-earmark-music-fill.svg": 697,
	"./file-earmark-music.svg": 696,
	"./file-earmark-pdf": 698,
	"./file-earmark-pdf-fill": 699,
	"./file-earmark-pdf-fill.svg": 699,
	"./file-earmark-pdf.svg": 698,
	"./file-earmark-person": 700,
	"./file-earmark-person-fill": 701,
	"./file-earmark-person-fill.svg": 701,
	"./file-earmark-person.svg": 700,
	"./file-earmark-play": 702,
	"./file-earmark-play-fill": 703,
	"./file-earmark-play-fill.svg": 703,
	"./file-earmark-play.svg": 702,
	"./file-earmark-plus": 704,
	"./file-earmark-plus-fill": 705,
	"./file-earmark-plus-fill.svg": 705,
	"./file-earmark-plus.svg": 704,
	"./file-earmark-post": 706,
	"./file-earmark-post-fill": 707,
	"./file-earmark-post-fill.svg": 707,
	"./file-earmark-post.svg": 706,
	"./file-earmark-ppt": 708,
	"./file-earmark-ppt-fill": 709,
	"./file-earmark-ppt-fill.svg": 709,
	"./file-earmark-ppt.svg": 708,
	"./file-earmark-richtext": 710,
	"./file-earmark-richtext-fill": 711,
	"./file-earmark-richtext-fill.svg": 711,
	"./file-earmark-richtext.svg": 710,
	"./file-earmark-ruled": 712,
	"./file-earmark-ruled-fill": 713,
	"./file-earmark-ruled-fill.svg": 713,
	"./file-earmark-ruled.svg": 712,
	"./file-earmark-slides": 714,
	"./file-earmark-slides-fill": 715,
	"./file-earmark-slides-fill.svg": 715,
	"./file-earmark-slides.svg": 714,
	"./file-earmark-spreadsheet": 716,
	"./file-earmark-spreadsheet-fill": 717,
	"./file-earmark-spreadsheet-fill.svg": 717,
	"./file-earmark-spreadsheet.svg": 716,
	"./file-earmark-text": 718,
	"./file-earmark-text-fill": 719,
	"./file-earmark-text-fill.svg": 719,
	"./file-earmark-text.svg": 718,
	"./file-earmark-word": 720,
	"./file-earmark-word-fill": 721,
	"./file-earmark-word-fill.svg": 721,
	"./file-earmark-word.svg": 720,
	"./file-earmark-x": 722,
	"./file-earmark-x-fill": 723,
	"./file-earmark-x-fill.svg": 723,
	"./file-earmark-x.svg": 722,
	"./file-earmark-zip": 724,
	"./file-earmark-zip-fill": 725,
	"./file-earmark-zip-fill.svg": 725,
	"./file-earmark-zip.svg": 724,
	"./file-earmark.svg": 662,
	"./file-easel": 726,
	"./file-easel-fill": 727,
	"./file-easel-fill.svg": 727,
	"./file-easel.svg": 726,
	"./file-excel": 728,
	"./file-excel-fill": 729,
	"./file-excel-fill.svg": 729,
	"./file-excel.svg": 728,
	"./file-fill": 730,
	"./file-fill.svg": 730,
	"./file-font": 731,
	"./file-font-fill": 732,
	"./file-font-fill.svg": 732,
	"./file-font.svg": 731,
	"./file-image": 733,
	"./file-image-fill": 734,
	"./file-image-fill.svg": 734,
	"./file-image.svg": 733,
	"./file-lock": 735,
	"./file-lock-fill": 736,
	"./file-lock-fill.svg": 736,
	"./file-lock.svg": 735,
	"./file-lock2": 737,
	"./file-lock2-fill": 738,
	"./file-lock2-fill.svg": 738,
	"./file-lock2.svg": 737,
	"./file-medical": 739,
	"./file-medical-fill": 740,
	"./file-medical-fill.svg": 740,
	"./file-medical.svg": 739,
	"./file-minus": 741,
	"./file-minus-fill": 742,
	"./file-minus-fill.svg": 742,
	"./file-minus.svg": 741,
	"./file-music": 743,
	"./file-music-fill": 744,
	"./file-music-fill.svg": 744,
	"./file-music.svg": 743,
	"./file-pdf": 745,
	"./file-pdf-fill": 746,
	"./file-pdf-fill.svg": 746,
	"./file-pdf.svg": 745,
	"./file-person": 747,
	"./file-person-fill": 748,
	"./file-person-fill.svg": 748,
	"./file-person.svg": 747,
	"./file-play": 749,
	"./file-play-fill": 750,
	"./file-play-fill.svg": 750,
	"./file-play.svg": 749,
	"./file-plus": 751,
	"./file-plus-fill": 752,
	"./file-plus-fill.svg": 752,
	"./file-plus.svg": 751,
	"./file-post": 753,
	"./file-post-fill": 754,
	"./file-post-fill.svg": 754,
	"./file-post.svg": 753,
	"./file-ppt": 755,
	"./file-ppt-fill": 756,
	"./file-ppt-fill.svg": 756,
	"./file-ppt.svg": 755,
	"./file-richtext": 757,
	"./file-richtext-fill": 758,
	"./file-richtext-fill.svg": 758,
	"./file-richtext.svg": 757,
	"./file-ruled": 759,
	"./file-ruled-fill": 760,
	"./file-ruled-fill.svg": 760,
	"./file-ruled.svg": 759,
	"./file-slides": 761,
	"./file-slides-fill": 762,
	"./file-slides-fill.svg": 762,
	"./file-slides.svg": 761,
	"./file-spreadsheet": 763,
	"./file-spreadsheet-fill": 764,
	"./file-spreadsheet-fill.svg": 764,
	"./file-spreadsheet.svg": 763,
	"./file-text": 765,
	"./file-text-fill": 766,
	"./file-text-fill.svg": 766,
	"./file-text.svg": 765,
	"./file-word": 767,
	"./file-word-fill": 768,
	"./file-word-fill.svg": 768,
	"./file-word.svg": 767,
	"./file-x": 769,
	"./file-x-fill": 770,
	"./file-x-fill.svg": 770,
	"./file-x.svg": 769,
	"./file-zip": 771,
	"./file-zip-fill": 772,
	"./file-zip-fill.svg": 772,
	"./file-zip.svg": 771,
	"./file.svg": 645,
	"./files": 773,
	"./files-alt": 774,
	"./files-alt.svg": 774,
	"./files.svg": 773,
	"./film": 775,
	"./film.svg": 775,
	"./filter": 776,
	"./filter-circle": 777,
	"./filter-circle-fill": 778,
	"./filter-circle-fill.svg": 778,
	"./filter-circle.svg": 777,
	"./filter-left": 779,
	"./filter-left.svg": 779,
	"./filter-right": 780,
	"./filter-right.svg": 780,
	"./filter-square": 781,
	"./filter-square-fill": 782,
	"./filter-square-fill.svg": 782,
	"./filter-square.svg": 781,
	"./filter.svg": 776,
	"./flag": 783,
	"./flag-fill": 784,
	"./flag-fill.svg": 784,
	"./flag.svg": 783,
	"./flower1": 785,
	"./flower1.svg": 785,
	"./flower2": 786,
	"./flower2.svg": 786,
	"./flower3": 787,
	"./flower3.svg": 787,
	"./folder": 788,
	"./folder-check": 789,
	"./folder-check.svg": 789,
	"./folder-fill": 790,
	"./folder-fill.svg": 790,
	"./folder-minus": 791,
	"./folder-minus.svg": 791,
	"./folder-plus": 792,
	"./folder-plus.svg": 792,
	"./folder-symlink": 793,
	"./folder-symlink-fill": 794,
	"./folder-symlink-fill.svg": 794,
	"./folder-symlink.svg": 793,
	"./folder-x": 795,
	"./folder-x.svg": 795,
	"./folder.svg": 788,
	"./folder2": 796,
	"./folder2-open": 797,
	"./folder2-open.svg": 797,
	"./folder2.svg": 796,
	"./fonts": 798,
	"./fonts.svg": 798,
	"./fonts/bootstrap-icons.woff": 1687,
	"./fonts/bootstrap-icons.woff2": 1688,
	"./forward": 799,
	"./forward-fill": 800,
	"./forward-fill.svg": 800,
	"./forward.svg": 799,
	"./front": 801,
	"./front.svg": 801,
	"./fullscreen": 802,
	"./fullscreen-exit": 803,
	"./fullscreen-exit.svg": 803,
	"./fullscreen.svg": 802,
	"./funnel": 804,
	"./funnel-fill": 805,
	"./funnel-fill.svg": 805,
	"./funnel.svg": 804,
	"./gear": 806,
	"./gear-fill": 807,
	"./gear-fill.svg": 807,
	"./gear-wide": 808,
	"./gear-wide-connected": 809,
	"./gear-wide-connected.svg": 809,
	"./gear-wide.svg": 808,
	"./gear.svg": 806,
	"./gem": 810,
	"./gem.svg": 810,
	"./gender-ambiguous": 811,
	"./gender-ambiguous.svg": 811,
	"./gender-female": 812,
	"./gender-female.svg": 812,
	"./gender-male": 813,
	"./gender-male.svg": 813,
	"./gender-trans": 814,
	"./gender-trans.svg": 814,
	"./geo": 815,
	"./geo-alt": 816,
	"./geo-alt-fill": 817,
	"./geo-alt-fill.svg": 817,
	"./geo-alt.svg": 816,
	"./geo-fill": 818,
	"./geo-fill.svg": 818,
	"./geo.svg": 815,
	"./gift": 819,
	"./gift-fill": 820,
	"./gift-fill.svg": 820,
	"./gift.svg": 819,
	"./github": 821,
	"./github.svg": 821,
	"./globe": 822,
	"./globe.svg": 822,
	"./globe2": 823,
	"./globe2.svg": 823,
	"./google": 824,
	"./google.svg": 824,
	"./graph-down": 825,
	"./graph-down.svg": 825,
	"./graph-up": 826,
	"./graph-up.svg": 826,
	"./grid": 827,
	"./grid-1x2": 828,
	"./grid-1x2-fill": 829,
	"./grid-1x2-fill.svg": 829,
	"./grid-1x2.svg": 828,
	"./grid-3x2": 830,
	"./grid-3x2-gap": 831,
	"./grid-3x2-gap-fill": 832,
	"./grid-3x2-gap-fill.svg": 832,
	"./grid-3x2-gap.svg": 831,
	"./grid-3x2.svg": 830,
	"./grid-3x3": 833,
	"./grid-3x3-gap": 834,
	"./grid-3x3-gap-fill": 835,
	"./grid-3x3-gap-fill.svg": 835,
	"./grid-3x3-gap.svg": 834,
	"./grid-3x3.svg": 833,
	"./grid-fill": 836,
	"./grid-fill.svg": 836,
	"./grid.svg": 827,
	"./grip-horizontal": 837,
	"./grip-horizontal.svg": 837,
	"./grip-vertical": 838,
	"./grip-vertical.svg": 838,
	"./hammer": 839,
	"./hammer.svg": 839,
	"./hand-index": 840,
	"./hand-index-fill": 841,
	"./hand-index-fill.svg": 841,
	"./hand-index-thumb": 842,
	"./hand-index-thumb-fill": 843,
	"./hand-index-thumb-fill.svg": 843,
	"./hand-index-thumb.svg": 842,
	"./hand-index.svg": 840,
	"./hand-thumbs-down": 844,
	"./hand-thumbs-down-fill": 845,
	"./hand-thumbs-down-fill.svg": 845,
	"./hand-thumbs-down.svg": 844,
	"./hand-thumbs-up": 846,
	"./hand-thumbs-up-fill": 847,
	"./hand-thumbs-up-fill.svg": 847,
	"./hand-thumbs-up.svg": 846,
	"./handbag": 848,
	"./handbag-fill": 849,
	"./handbag-fill.svg": 849,
	"./handbag.svg": 848,
	"./hash": 850,
	"./hash.svg": 850,
	"./hdd": 851,
	"./hdd-fill": 852,
	"./hdd-fill.svg": 852,
	"./hdd-network": 853,
	"./hdd-network-fill": 854,
	"./hdd-network-fill.svg": 854,
	"./hdd-network.svg": 853,
	"./hdd-rack": 855,
	"./hdd-rack-fill": 856,
	"./hdd-rack-fill.svg": 856,
	"./hdd-rack.svg": 855,
	"./hdd-stack": 857,
	"./hdd-stack-fill": 858,
	"./hdd-stack-fill.svg": 858,
	"./hdd-stack.svg": 857,
	"./hdd.svg": 851,
	"./headphones": 859,
	"./headphones.svg": 859,
	"./headset": 860,
	"./headset-vr": 861,
	"./headset-vr.svg": 861,
	"./headset.svg": 860,
	"./heart": 862,
	"./heart-fill": 863,
	"./heart-fill.svg": 863,
	"./heart-half": 864,
	"./heart-half.svg": 864,
	"./heart.svg": 862,
	"./heptagon": 865,
	"./heptagon-fill": 866,
	"./heptagon-fill.svg": 866,
	"./heptagon-half": 867,
	"./heptagon-half.svg": 867,
	"./heptagon.svg": 865,
	"./hexagon": 868,
	"./hexagon-fill": 869,
	"./hexagon-fill.svg": 869,
	"./hexagon-half": 870,
	"./hexagon-half.svg": 870,
	"./hexagon.svg": 868,
	"./hourglass": 871,
	"./hourglass-bottom": 872,
	"./hourglass-bottom.svg": 872,
	"./hourglass-split": 873,
	"./hourglass-split.svg": 873,
	"./hourglass-top": 874,
	"./hourglass-top.svg": 874,
	"./hourglass.svg": 871,
	"./house": 875,
	"./house-door": 876,
	"./house-door-fill": 877,
	"./house-door-fill.svg": 877,
	"./house-door.svg": 876,
	"./house-fill": 878,
	"./house-fill.svg": 878,
	"./house.svg": 875,
	"./hr": 879,
	"./hr.svg": 879,
	"./hurricane": 880,
	"./hurricane.svg": 880,
	"./image": 881,
	"./image-alt": 882,
	"./image-alt.svg": 882,
	"./image-fill": 883,
	"./image-fill.svg": 883,
	"./image.svg": 881,
	"./images": 884,
	"./images.svg": 884,
	"./img-teste": 885,
	"./img-teste.png": 885,
	"./inbox": 886,
	"./inbox-fill": 887,
	"./inbox-fill.svg": 887,
	"./inbox.svg": 886,
	"./inboxes": 888,
	"./inboxes-fill": 889,
	"./inboxes-fill.svg": 889,
	"./inboxes.svg": 888,
	"./info": 890,
	"./info-circle": 891,
	"./info-circle-fill": 892,
	"./info-circle-fill.svg": 892,
	"./info-circle.svg": 891,
	"./info-lg": 893,
	"./info-lg.svg": 893,
	"./info-square": 894,
	"./info-square-fill": 895,
	"./info-square-fill.svg": 895,
	"./info-square.svg": 894,
	"./info.svg": 890,
	"./input-cursor": 896,
	"./input-cursor-text": 897,
	"./input-cursor-text.svg": 897,
	"./input-cursor.svg": 896,
	"./instagram": 898,
	"./instagram.svg": 898,
	"./intersect": 899,
	"./intersect.svg": 899,
	"./journal": 900,
	"./journal-album": 901,
	"./journal-album.svg": 901,
	"./journal-arrow-down": 902,
	"./journal-arrow-down.svg": 902,
	"./journal-arrow-up": 903,
	"./journal-arrow-up.svg": 903,
	"./journal-bookmark": 904,
	"./journal-bookmark-fill": 905,
	"./journal-bookmark-fill.svg": 905,
	"./journal-bookmark.svg": 904,
	"./journal-check": 906,
	"./journal-check.svg": 906,
	"./journal-code": 907,
	"./journal-code.svg": 907,
	"./journal-medical": 908,
	"./journal-medical.svg": 908,
	"./journal-minus": 909,
	"./journal-minus.svg": 909,
	"./journal-plus": 910,
	"./journal-plus.svg": 910,
	"./journal-richtext": 911,
	"./journal-richtext.svg": 911,
	"./journal-text": 912,
	"./journal-text.svg": 912,
	"./journal-x": 913,
	"./journal-x.svg": 913,
	"./journal.svg": 900,
	"./journals": 914,
	"./journals.svg": 914,
	"./joystick": 915,
	"./joystick.svg": 915,
	"./justify": 916,
	"./justify-left": 917,
	"./justify-left.svg": 917,
	"./justify-right": 918,
	"./justify-right.svg": 918,
	"./justify.svg": 916,
	"./kanban": 919,
	"./kanban-fill": 920,
	"./kanban-fill.svg": 920,
	"./kanban.svg": 919,
	"./key": 921,
	"./key-fill": 922,
	"./key-fill.svg": 922,
	"./key.svg": 921,
	"./keyboard": 923,
	"./keyboard-fill": 924,
	"./keyboard-fill.svg": 924,
	"./keyboard.svg": 923,
	"./ladder": 925,
	"./ladder.svg": 925,
	"./lamp": 926,
	"./lamp-fill": 927,
	"./lamp-fill.svg": 927,
	"./lamp.svg": 926,
	"./laptop": 928,
	"./laptop-fill": 929,
	"./laptop-fill.svg": 929,
	"./laptop.svg": 928,
	"./layer-backward": 930,
	"./layer-backward.svg": 930,
	"./layer-forward": 931,
	"./layer-forward.svg": 931,
	"./layers": 932,
	"./layers-fill": 933,
	"./layers-fill.svg": 933,
	"./layers-half": 934,
	"./layers-half.svg": 934,
	"./layers.svg": 932,
	"./layout-sidebar": 935,
	"./layout-sidebar-inset": 936,
	"./layout-sidebar-inset-reverse": 937,
	"./layout-sidebar-inset-reverse.svg": 937,
	"./layout-sidebar-inset.svg": 936,
	"./layout-sidebar-reverse": 938,
	"./layout-sidebar-reverse.svg": 938,
	"./layout-sidebar.svg": 935,
	"./layout-split": 939,
	"./layout-split.svg": 939,
	"./layout-text-sidebar": 940,
	"./layout-text-sidebar-reverse": 941,
	"./layout-text-sidebar-reverse.svg": 941,
	"./layout-text-sidebar.svg": 940,
	"./layout-text-window": 942,
	"./layout-text-window-reverse": 943,
	"./layout-text-window-reverse.svg": 943,
	"./layout-text-window.svg": 942,
	"./layout-three-columns": 944,
	"./layout-three-columns.svg": 944,
	"./layout-wtf": 945,
	"./layout-wtf.svg": 945,
	"./life-preserver": 946,
	"./life-preserver.svg": 946,
	"./lightbulb": 947,
	"./lightbulb-fill": 948,
	"./lightbulb-fill.svg": 948,
	"./lightbulb-off": 949,
	"./lightbulb-off-fill": 950,
	"./lightbulb-off-fill.svg": 950,
	"./lightbulb-off.svg": 949,
	"./lightbulb.svg": 947,
	"./lightning": 951,
	"./lightning-charge": 952,
	"./lightning-charge-fill": 953,
	"./lightning-charge-fill.svg": 953,
	"./lightning-charge.svg": 952,
	"./lightning-fill": 954,
	"./lightning-fill.svg": 954,
	"./lightning.svg": 951,
	"./link": 955,
	"./link-45deg": 956,
	"./link-45deg.svg": 956,
	"./link.svg": 955,
	"./linkedin": 957,
	"./linkedin.svg": 957,
	"./list": 958,
	"./list-check": 959,
	"./list-check.svg": 959,
	"./list-nested": 960,
	"./list-nested.svg": 960,
	"./list-ol": 961,
	"./list-ol.svg": 961,
	"./list-stars": 962,
	"./list-stars.svg": 962,
	"./list-task": 963,
	"./list-task.svg": 963,
	"./list-ul": 964,
	"./list-ul.svg": 964,
	"./list.svg": 958,
	"./lock": 965,
	"./lock-fill": 966,
	"./lock-fill.svg": 966,
	"./lock.svg": 965,
	"./mailbox": 967,
	"./mailbox.svg": 967,
	"./mailbox2": 968,
	"./mailbox2.svg": 968,
	"./map": 969,
	"./map-fill": 970,
	"./map-fill.svg": 970,
	"./map.svg": 969,
	"./markdown": 971,
	"./markdown-fill": 972,
	"./markdown-fill.svg": 972,
	"./markdown.svg": 971,
	"./mask": 973,
	"./mask.svg": 973,
	"./mastodon": 974,
	"./mastodon.svg": 974,
	"./megaphone": 975,
	"./megaphone-fill": 976,
	"./megaphone-fill.svg": 976,
	"./megaphone.svg": 975,
	"./menu-app": 977,
	"./menu-app-fill": 978,
	"./menu-app-fill.svg": 978,
	"./menu-app.svg": 977,
	"./menu-button": 979,
	"./menu-button-fill": 980,
	"./menu-button-fill.svg": 980,
	"./menu-button-wide": 981,
	"./menu-button-wide-fill": 982,
	"./menu-button-wide-fill.svg": 982,
	"./menu-button-wide.svg": 981,
	"./menu-button.svg": 979,
	"./menu-down": 983,
	"./menu-down.svg": 983,
	"./menu-up": 984,
	"./menu-up.svg": 984,
	"./messenger": 985,
	"./messenger.svg": 985,
	"./mic": 986,
	"./mic-fill": 987,
	"./mic-fill.svg": 987,
	"./mic-mute": 988,
	"./mic-mute-fill": 989,
	"./mic-mute-fill.svg": 989,
	"./mic-mute.svg": 988,
	"./mic.svg": 986,
	"./minecart": 990,
	"./minecart-loaded": 991,
	"./minecart-loaded.svg": 991,
	"./minecart.svg": 990,
	"./moisture": 992,
	"./moisture.svg": 992,
	"./moon": 993,
	"./moon-fill": 994,
	"./moon-fill.svg": 994,
	"./moon-stars": 995,
	"./moon-stars-fill": 996,
	"./moon-stars-fill.svg": 996,
	"./moon-stars.svg": 995,
	"./moon.svg": 993,
	"./mortarboard": 997,
	"./mortarboard.svg": 997,
	"./mouse": 998,
	"./mouse-fill": 999,
	"./mouse-fill.svg": 999,
	"./mouse.svg": 998,
	"./mouse2": 1000,
	"./mouse2-fill": 1001,
	"./mouse2-fill.svg": 1001,
	"./mouse2.svg": 1000,
	"./mouse3": 1002,
	"./mouse3-fill": 1003,
	"./mouse3-fill.svg": 1003,
	"./mouse3.svg": 1002,
	"./music-note": 1004,
	"./music-note-beamed": 1005,
	"./music-note-beamed.svg": 1005,
	"./music-note-list": 1006,
	"./music-note-list.svg": 1006,
	"./music-note.svg": 1004,
	"./music-player": 1007,
	"./music-player-fill": 1008,
	"./music-player-fill.svg": 1008,
	"./music-player.svg": 1007,
	"./newspaper": 1009,
	"./newspaper.svg": 1009,
	"./node-minus": 1010,
	"./node-minus-fill": 1011,
	"./node-minus-fill.svg": 1011,
	"./node-minus.svg": 1010,
	"./node-plus": 1012,
	"./node-plus-fill": 1013,
	"./node-plus-fill.svg": 1013,
	"./node-plus.svg": 1012,
	"./nut": 1014,
	"./nut-fill": 1015,
	"./nut-fill.svg": 1015,
	"./nut.svg": 1014,
	"./octagon": 1016,
	"./octagon-fill": 1017,
	"./octagon-fill.svg": 1017,
	"./octagon-half": 1018,
	"./octagon-half.svg": 1018,
	"./octagon.svg": 1016,
	"./option": 1019,
	"./option.svg": 1019,
	"./outlet": 1020,
	"./outlet.svg": 1020,
	"./paint-bucket": 1021,
	"./paint-bucket.svg": 1021,
	"./palette": 1022,
	"./palette-fill": 1023,
	"./palette-fill.svg": 1023,
	"./palette.svg": 1022,
	"./palette2": 1024,
	"./palette2.svg": 1024,
	"./paperclip": 1025,
	"./paperclip.svg": 1025,
	"./paragraph": 1026,
	"./paragraph.svg": 1026,
	"./patch-check": 1027,
	"./patch-check-fill": 1028,
	"./patch-check-fill.svg": 1028,
	"./patch-check.svg": 1027,
	"./patch-exclamation": 1029,
	"./patch-exclamation-fill": 1030,
	"./patch-exclamation-fill.svg": 1030,
	"./patch-exclamation.svg": 1029,
	"./patch-minus": 1031,
	"./patch-minus-fill": 1032,
	"./patch-minus-fill.svg": 1032,
	"./patch-minus.svg": 1031,
	"./patch-plus": 1033,
	"./patch-plus-fill": 1034,
	"./patch-plus-fill.svg": 1034,
	"./patch-plus.svg": 1033,
	"./patch-question": 1035,
	"./patch-question-fill": 1036,
	"./patch-question-fill.svg": 1036,
	"./patch-question.svg": 1035,
	"./pause": 1037,
	"./pause-btn": 1038,
	"./pause-btn-fill": 1039,
	"./pause-btn-fill.svg": 1039,
	"./pause-btn.svg": 1038,
	"./pause-circle": 1040,
	"./pause-circle-fill": 1041,
	"./pause-circle-fill.svg": 1041,
	"./pause-circle.svg": 1040,
	"./pause-fill": 1042,
	"./pause-fill.svg": 1042,
	"./pause.svg": 1037,
	"./peace": 1043,
	"./peace-fill": 1044,
	"./peace-fill.svg": 1044,
	"./peace.svg": 1043,
	"./pen": 1045,
	"./pen-fill": 1046,
	"./pen-fill.svg": 1046,
	"./pen.svg": 1045,
	"./pencil": 1047,
	"./pencil-fill": 1048,
	"./pencil-fill.svg": 1048,
	"./pencil-square": 1049,
	"./pencil-square.svg": 1049,
	"./pencil.svg": 1047,
	"./pentagon": 1050,
	"./pentagon-fill": 1051,
	"./pentagon-fill.svg": 1051,
	"./pentagon-half": 1052,
	"./pentagon-half.svg": 1052,
	"./pentagon.svg": 1050,
	"./people": 1053,
	"./people-fill": 1054,
	"./people-fill.svg": 1054,
	"./people.svg": 1053,
	"./percent": 1055,
	"./percent.svg": 1055,
	"./person": 1056,
	"./person-badge": 1057,
	"./person-badge-fill": 1058,
	"./person-badge-fill.svg": 1058,
	"./person-badge.svg": 1057,
	"./person-bounding-box": 1059,
	"./person-bounding-box.svg": 1059,
	"./person-check": 1060,
	"./person-check-fill": 1061,
	"./person-check-fill.svg": 1061,
	"./person-check.svg": 1060,
	"./person-circle": 1062,
	"./person-circle.svg": 1062,
	"./person-dash": 1063,
	"./person-dash-fill": 1064,
	"./person-dash-fill.svg": 1064,
	"./person-dash.svg": 1063,
	"./person-fill": 1065,
	"./person-fill.svg": 1065,
	"./person-lines-fill": 1066,
	"./person-lines-fill.svg": 1066,
	"./person-plus": 1067,
	"./person-plus-fill": 1068,
	"./person-plus-fill.svg": 1068,
	"./person-plus.svg": 1067,
	"./person-square": 1069,
	"./person-square.svg": 1069,
	"./person-x": 1070,
	"./person-x-fill": 1071,
	"./person-x-fill.svg": 1071,
	"./person-x.svg": 1070,
	"./person.svg": 1056,
	"./phone": 1072,
	"./phone-fill": 1073,
	"./phone-fill.svg": 1073,
	"./phone-landscape": 1074,
	"./phone-landscape-fill": 1075,
	"./phone-landscape-fill.svg": 1075,
	"./phone-landscape.svg": 1074,
	"./phone-vibrate": 1076,
	"./phone-vibrate-fill": 1077,
	"./phone-vibrate-fill.svg": 1077,
	"./phone-vibrate.svg": 1076,
	"./phone.svg": 1072,
	"./pie-chart": 1078,
	"./pie-chart-fill": 1079,
	"./pie-chart-fill.svg": 1079,
	"./pie-chart.svg": 1078,
	"./piggy-bank": 1080,
	"./piggy-bank-fill": 1081,
	"./piggy-bank-fill.svg": 1081,
	"./piggy-bank.svg": 1080,
	"./pin": 1082,
	"./pin-angle": 1083,
	"./pin-angle-fill": 1084,
	"./pin-angle-fill.svg": 1084,
	"./pin-angle.svg": 1083,
	"./pin-fill": 1085,
	"./pin-fill.svg": 1085,
	"./pin-map": 1086,
	"./pin-map-fill": 1087,
	"./pin-map-fill.svg": 1087,
	"./pin-map.svg": 1086,
	"./pin.svg": 1082,
	"./pip": 1088,
	"./pip-fill": 1089,
	"./pip-fill.svg": 1089,
	"./pip.svg": 1088,
	"./play": 1090,
	"./play-btn": 1091,
	"./play-btn-fill": 1092,
	"./play-btn-fill.svg": 1092,
	"./play-btn.svg": 1091,
	"./play-circle": 1093,
	"./play-circle-fill": 1094,
	"./play-circle-fill.svg": 1094,
	"./play-circle.svg": 1093,
	"./play-fill": 1095,
	"./play-fill.svg": 1095,
	"./play.svg": 1090,
	"./plug": 1096,
	"./plug-fill": 1097,
	"./plug-fill.svg": 1097,
	"./plug.svg": 1096,
	"./plus": 1098,
	"./plus-circle": 1099,
	"./plus-circle-dotted": 1100,
	"./plus-circle-dotted.svg": 1100,
	"./plus-circle-fill": 1101,
	"./plus-circle-fill.svg": 1101,
	"./plus-circle.svg": 1099,
	"./plus-lg": 1102,
	"./plus-lg.svg": 1102,
	"./plus-square": 1103,
	"./plus-square-dotted": 1104,
	"./plus-square-dotted.svg": 1104,
	"./plus-square-fill": 1105,
	"./plus-square-fill.svg": 1105,
	"./plus-square.svg": 1103,
	"./plus.svg": 1098,
	"./power": 1106,
	"./power.svg": 1106,
	"./printer": 1107,
	"./printer-fill": 1108,
	"./printer-fill.svg": 1108,
	"./printer.svg": 1107,
	"./puzzle": 1109,
	"./puzzle-fill": 1110,
	"./puzzle-fill.svg": 1110,
	"./puzzle.svg": 1109,
	"./question": 1111,
	"./question-circle": 1112,
	"./question-circle-fill": 1113,
	"./question-circle-fill.svg": 1113,
	"./question-circle.svg": 1112,
	"./question-diamond": 1114,
	"./question-diamond-fill": 1115,
	"./question-diamond-fill.svg": 1115,
	"./question-diamond.svg": 1114,
	"./question-lg": 1116,
	"./question-lg.svg": 1116,
	"./question-octagon": 1117,
	"./question-octagon-fill": 1118,
	"./question-octagon-fill.svg": 1118,
	"./question-octagon.svg": 1117,
	"./question-square": 1119,
	"./question-square-fill": 1120,
	"./question-square-fill.svg": 1120,
	"./question-square.svg": 1119,
	"./question.svg": 1111,
	"./rainbow": 1121,
	"./rainbow.svg": 1121,
	"./receipt": 1122,
	"./receipt-cutoff": 1123,
	"./receipt-cutoff.svg": 1123,
	"./receipt.svg": 1122,
	"./reception-0": 1124,
	"./reception-0.svg": 1124,
	"./reception-1": 1125,
	"./reception-1.svg": 1125,
	"./reception-2": 1126,
	"./reception-2.svg": 1126,
	"./reception-3": 1127,
	"./reception-3.svg": 1127,
	"./reception-4": 1128,
	"./reception-4.svg": 1128,
	"./record": 1129,
	"./record-btn": 1130,
	"./record-btn-fill": 1131,
	"./record-btn-fill.svg": 1131,
	"./record-btn.svg": 1130,
	"./record-circle": 1132,
	"./record-circle-fill": 1133,
	"./record-circle-fill.svg": 1133,
	"./record-circle.svg": 1132,
	"./record-fill": 1134,
	"./record-fill.svg": 1134,
	"./record.svg": 1129,
	"./record2": 1135,
	"./record2-fill": 1136,
	"./record2-fill.svg": 1136,
	"./record2.svg": 1135,
	"./recycle": 1137,
	"./recycle.svg": 1137,
	"./reddit": 1138,
	"./reddit.svg": 1138,
	"./reply": 1139,
	"./reply-all": 1140,
	"./reply-all-fill": 1141,
	"./reply-all-fill.svg": 1141,
	"./reply-all.svg": 1140,
	"./reply-fill": 1142,
	"./reply-fill.svg": 1142,
	"./reply.svg": 1139,
	"./rss": 1143,
	"./rss-fill": 1144,
	"./rss-fill.svg": 1144,
	"./rss.svg": 1143,
	"./rulers": 1145,
	"./rulers.svg": 1145,
	"./safe": 1146,
	"./safe-fill": 1147,
	"./safe-fill.svg": 1147,
	"./safe.svg": 1146,
	"./safe2": 1148,
	"./safe2-fill": 1149,
	"./safe2-fill.svg": 1149,
	"./safe2.svg": 1148,
	"./save": 1150,
	"./save-fill": 1151,
	"./save-fill.svg": 1151,
	"./save.svg": 1150,
	"./save2": 1152,
	"./save2-fill": 1153,
	"./save2-fill.svg": 1153,
	"./save2.svg": 1152,
	"./scissors": 1154,
	"./scissors.svg": 1154,
	"./screwdriver": 1155,
	"./screwdriver.svg": 1155,
	"./sd-card": 1156,
	"./sd-card-fill": 1157,
	"./sd-card-fill.svg": 1157,
	"./sd-card.svg": 1156,
	"./search": 1158,
	"./search.svg": 1158,
	"./segmented-nav": 1159,
	"./segmented-nav.svg": 1159,
	"./server": 1160,
	"./server.svg": 1160,
	"./share": 1161,
	"./share-fill": 1162,
	"./share-fill.svg": 1162,
	"./share.svg": 1161,
	"./shield": 1163,
	"./shield-check": 1164,
	"./shield-check.svg": 1164,
	"./shield-exclamation": 1165,
	"./shield-exclamation.svg": 1165,
	"./shield-fill": 1166,
	"./shield-fill-check": 1167,
	"./shield-fill-check.svg": 1167,
	"./shield-fill-exclamation": 1168,
	"./shield-fill-exclamation.svg": 1168,
	"./shield-fill-minus": 1169,
	"./shield-fill-minus.svg": 1169,
	"./shield-fill-plus": 1170,
	"./shield-fill-plus.svg": 1170,
	"./shield-fill-x": 1171,
	"./shield-fill-x.svg": 1171,
	"./shield-fill.svg": 1166,
	"./shield-lock": 1172,
	"./shield-lock-fill": 1173,
	"./shield-lock-fill.svg": 1173,
	"./shield-lock.svg": 1172,
	"./shield-minus": 1174,
	"./shield-minus.svg": 1174,
	"./shield-plus": 1175,
	"./shield-plus.svg": 1175,
	"./shield-shaded": 1176,
	"./shield-shaded.svg": 1176,
	"./shield-slash": 1177,
	"./shield-slash-fill": 1178,
	"./shield-slash-fill.svg": 1178,
	"./shield-slash.svg": 1177,
	"./shield-x": 1179,
	"./shield-x.svg": 1179,
	"./shield.svg": 1163,
	"./shift": 1180,
	"./shift-fill": 1181,
	"./shift-fill.svg": 1181,
	"./shift.svg": 1180,
	"./shop": 1182,
	"./shop-window": 1183,
	"./shop-window.svg": 1183,
	"./shop.svg": 1182,
	"./shuffle": 1184,
	"./shuffle.svg": 1184,
	"./signpost": 1185,
	"./signpost-2": 1186,
	"./signpost-2-fill": 1187,
	"./signpost-2-fill.svg": 1187,
	"./signpost-2.svg": 1186,
	"./signpost-fill": 1188,
	"./signpost-fill.svg": 1188,
	"./signpost-split": 1189,
	"./signpost-split-fill": 1190,
	"./signpost-split-fill.svg": 1190,
	"./signpost-split.svg": 1189,
	"./signpost.svg": 1185,
	"./sim": 1191,
	"./sim-fill": 1192,
	"./sim-fill.svg": 1192,
	"./sim.svg": 1191,
	"./skip-backward": 1193,
	"./skip-backward-btn": 1194,
	"./skip-backward-btn-fill": 1195,
	"./skip-backward-btn-fill.svg": 1195,
	"./skip-backward-btn.svg": 1194,
	"./skip-backward-circle": 1196,
	"./skip-backward-circle-fill": 1197,
	"./skip-backward-circle-fill.svg": 1197,
	"./skip-backward-circle.svg": 1196,
	"./skip-backward-fill": 1198,
	"./skip-backward-fill.svg": 1198,
	"./skip-backward.svg": 1193,
	"./skip-end": 1199,
	"./skip-end-btn": 1200,
	"./skip-end-btn-fill": 1201,
	"./skip-end-btn-fill.svg": 1201,
	"./skip-end-btn.svg": 1200,
	"./skip-end-circle": 1202,
	"./skip-end-circle-fill": 1203,
	"./skip-end-circle-fill.svg": 1203,
	"./skip-end-circle.svg": 1202,
	"./skip-end-fill": 1204,
	"./skip-end-fill.svg": 1204,
	"./skip-end.svg": 1199,
	"./skip-forward": 1205,
	"./skip-forward-btn": 1206,
	"./skip-forward-btn-fill": 1207,
	"./skip-forward-btn-fill.svg": 1207,
	"./skip-forward-btn.svg": 1206,
	"./skip-forward-circle": 1208,
	"./skip-forward-circle-fill": 1209,
	"./skip-forward-circle-fill.svg": 1209,
	"./skip-forward-circle.svg": 1208,
	"./skip-forward-fill": 1210,
	"./skip-forward-fill.svg": 1210,
	"./skip-forward.svg": 1205,
	"./skip-start": 1211,
	"./skip-start-btn": 1212,
	"./skip-start-btn-fill": 1213,
	"./skip-start-btn-fill.svg": 1213,
	"./skip-start-btn.svg": 1212,
	"./skip-start-circle": 1214,
	"./skip-start-circle-fill": 1215,
	"./skip-start-circle-fill.svg": 1215,
	"./skip-start-circle.svg": 1214,
	"./skip-start-fill": 1216,
	"./skip-start-fill.svg": 1216,
	"./skip-start.svg": 1211,
	"./skype": 1217,
	"./skype.svg": 1217,
	"./slack": 1218,
	"./slack.svg": 1218,
	"./slash": 1219,
	"./slash-circle": 1220,
	"./slash-circle-fill": 1221,
	"./slash-circle-fill.svg": 1221,
	"./slash-circle.svg": 1220,
	"./slash-lg": 1222,
	"./slash-lg.svg": 1222,
	"./slash-square": 1223,
	"./slash-square-fill": 1224,
	"./slash-square-fill.svg": 1224,
	"./slash-square.svg": 1223,
	"./slash.svg": 1219,
	"./sliders": 1225,
	"./sliders.svg": 1225,
	"./smartwatch": 1226,
	"./smartwatch.svg": 1226,
	"./snow": 1227,
	"./snow.svg": 1227,
	"./snow2": 1228,
	"./snow2.svg": 1228,
	"./snow3": 1229,
	"./snow3.svg": 1229,
	"./sort-alpha-down": 1230,
	"./sort-alpha-down-alt": 1231,
	"./sort-alpha-down-alt.svg": 1231,
	"./sort-alpha-down.svg": 1230,
	"./sort-alpha-up": 1232,
	"./sort-alpha-up-alt": 1233,
	"./sort-alpha-up-alt.svg": 1233,
	"./sort-alpha-up.svg": 1232,
	"./sort-down": 1234,
	"./sort-down-alt": 1235,
	"./sort-down-alt.svg": 1235,
	"./sort-down.svg": 1234,
	"./sort-numeric-down": 1236,
	"./sort-numeric-down-alt": 1237,
	"./sort-numeric-down-alt.svg": 1237,
	"./sort-numeric-down.svg": 1236,
	"./sort-numeric-up": 1238,
	"./sort-numeric-up-alt": 1239,
	"./sort-numeric-up-alt.svg": 1239,
	"./sort-numeric-up.svg": 1238,
	"./sort-up": 1240,
	"./sort-up-alt": 1241,
	"./sort-up-alt.svg": 1241,
	"./sort-up.svg": 1240,
	"./soundwave": 1242,
	"./soundwave.svg": 1242,
	"./speaker": 1243,
	"./speaker-fill": 1244,
	"./speaker-fill.svg": 1244,
	"./speaker.svg": 1243,
	"./speedometer": 1245,
	"./speedometer.svg": 1245,
	"./speedometer2": 1246,
	"./speedometer2.svg": 1246,
	"./spellcheck": 1247,
	"./spellcheck.svg": 1247,
	"./square": 1248,
	"./square-fill": 1249,
	"./square-fill.svg": 1249,
	"./square-half": 1250,
	"./square-half.svg": 1250,
	"./square.svg": 1248,
	"./stack": 1251,
	"./stack.svg": 1251,
	"./star": 1252,
	"./star-fill": 1253,
	"./star-fill.svg": 1253,
	"./star-half": 1254,
	"./star-half.svg": 1254,
	"./star.svg": 1252,
	"./stars": 1255,
	"./stars.svg": 1255,
	"./stickies": 1256,
	"./stickies-fill": 1257,
	"./stickies-fill.svg": 1257,
	"./stickies.svg": 1256,
	"./sticky": 1258,
	"./sticky-fill": 1259,
	"./sticky-fill.svg": 1259,
	"./sticky.svg": 1258,
	"./stop": 1260,
	"./stop-btn": 1261,
	"./stop-btn-fill": 1262,
	"./stop-btn-fill.svg": 1262,
	"./stop-btn.svg": 1261,
	"./stop-circle": 1263,
	"./stop-circle-fill": 1264,
	"./stop-circle-fill.svg": 1264,
	"./stop-circle.svg": 1263,
	"./stop-fill": 1265,
	"./stop-fill.svg": 1265,
	"./stop.svg": 1260,
	"./stoplights": 1266,
	"./stoplights-fill": 1267,
	"./stoplights-fill.svg": 1267,
	"./stoplights.svg": 1266,
	"./stopwatch": 1268,
	"./stopwatch-fill": 1269,
	"./stopwatch-fill.svg": 1269,
	"./stopwatch.svg": 1268,
	"./subtract": 1270,
	"./subtract.svg": 1270,
	"./suit-club": 1271,
	"./suit-club-fill": 1272,
	"./suit-club-fill.svg": 1272,
	"./suit-club.svg": 1271,
	"./suit-diamond": 1273,
	"./suit-diamond-fill": 1274,
	"./suit-diamond-fill.svg": 1274,
	"./suit-diamond.svg": 1273,
	"./suit-heart": 1275,
	"./suit-heart-fill": 1276,
	"./suit-heart-fill.svg": 1276,
	"./suit-heart.svg": 1275,
	"./suit-spade": 1277,
	"./suit-spade-fill": 1278,
	"./suit-spade-fill.svg": 1278,
	"./suit-spade.svg": 1277,
	"./sun": 1279,
	"./sun-fill": 1280,
	"./sun-fill.svg": 1280,
	"./sun.svg": 1279,
	"./sunglasses": 1281,
	"./sunglasses.svg": 1281,
	"./sunrise": 1282,
	"./sunrise-fill": 1283,
	"./sunrise-fill.svg": 1283,
	"./sunrise.svg": 1282,
	"./sunset": 1284,
	"./sunset-fill": 1285,
	"./sunset-fill.svg": 1285,
	"./sunset.svg": 1284,
	"./symmetry-horizontal": 1286,
	"./symmetry-horizontal.svg": 1286,
	"./symmetry-vertical": 1287,
	"./symmetry-vertical.svg": 1287,
	"./table": 1288,
	"./table.svg": 1288,
	"./tablet": 1289,
	"./tablet-fill": 1290,
	"./tablet-fill.svg": 1290,
	"./tablet-landscape": 1291,
	"./tablet-landscape-fill": 1292,
	"./tablet-landscape-fill.svg": 1292,
	"./tablet-landscape.svg": 1291,
	"./tablet.svg": 1289,
	"./tag": 1293,
	"./tag-fill": 1294,
	"./tag-fill.svg": 1294,
	"./tag.svg": 1293,
	"./tags": 1295,
	"./tags-fill": 1296,
	"./tags-fill.svg": 1296,
	"./tags.svg": 1295,
	"./telegram": 1297,
	"./telegram.svg": 1297,
	"./telephone": 1298,
	"./telephone-fill": 1299,
	"./telephone-fill.svg": 1299,
	"./telephone-forward": 1300,
	"./telephone-forward-fill": 1301,
	"./telephone-forward-fill.svg": 1301,
	"./telephone-forward.svg": 1300,
	"./telephone-inbound": 1302,
	"./telephone-inbound-fill": 1303,
	"./telephone-inbound-fill.svg": 1303,
	"./telephone-inbound.svg": 1302,
	"./telephone-minus": 1304,
	"./telephone-minus-fill": 1305,
	"./telephone-minus-fill.svg": 1305,
	"./telephone-minus.svg": 1304,
	"./telephone-outbound": 1306,
	"./telephone-outbound-fill": 1307,
	"./telephone-outbound-fill.svg": 1307,
	"./telephone-outbound.svg": 1306,
	"./telephone-plus": 1308,
	"./telephone-plus-fill": 1309,
	"./telephone-plus-fill.svg": 1309,
	"./telephone-plus.svg": 1308,
	"./telephone-x": 1310,
	"./telephone-x-fill": 1311,
	"./telephone-x-fill.svg": 1311,
	"./telephone-x.svg": 1310,
	"./telephone.svg": 1298,
	"./terminal": 1312,
	"./terminal-fill": 1313,
	"./terminal-fill.svg": 1313,
	"./terminal.svg": 1312,
	"./text-center": 1314,
	"./text-center.svg": 1314,
	"./text-indent-left": 1315,
	"./text-indent-left.svg": 1315,
	"./text-indent-right": 1316,
	"./text-indent-right.svg": 1316,
	"./text-left": 1317,
	"./text-left.svg": 1317,
	"./text-paragraph": 1318,
	"./text-paragraph.svg": 1318,
	"./text-right": 1319,
	"./text-right.svg": 1319,
	"./textarea": 1320,
	"./textarea-resize": 1321,
	"./textarea-resize.svg": 1321,
	"./textarea-t": 1322,
	"./textarea-t.svg": 1322,
	"./textarea.svg": 1320,
	"./thermometer": 1323,
	"./thermometer-half": 1324,
	"./thermometer-half.svg": 1324,
	"./thermometer-high": 1325,
	"./thermometer-high.svg": 1325,
	"./thermometer-low": 1326,
	"./thermometer-low.svg": 1326,
	"./thermometer-snow": 1327,
	"./thermometer-snow.svg": 1327,
	"./thermometer-sun": 1328,
	"./thermometer-sun.svg": 1328,
	"./thermometer.svg": 1323,
	"./three-dots": 1329,
	"./three-dots-vertical": 1330,
	"./three-dots-vertical.svg": 1330,
	"./three-dots.svg": 1329,
	"./toggle-off": 1331,
	"./toggle-off.svg": 1331,
	"./toggle-on": 1332,
	"./toggle-on.svg": 1332,
	"./toggle2-off": 1333,
	"./toggle2-off.svg": 1333,
	"./toggle2-on": 1334,
	"./toggle2-on.svg": 1334,
	"./toggles": 1335,
	"./toggles.svg": 1335,
	"./toggles2": 1336,
	"./toggles2.svg": 1336,
	"./tools": 1337,
	"./tools.svg": 1337,
	"./tornado": 1338,
	"./tornado.svg": 1338,
	"./translate": 1339,
	"./translate.svg": 1339,
	"./trash": 1340,
	"./trash-fill": 1341,
	"./trash-fill.svg": 1341,
	"./trash.svg": 1340,
	"./trash2": 1342,
	"./trash2-fill": 1343,
	"./trash2-fill.svg": 1343,
	"./trash2.svg": 1342,
	"./tree": 1344,
	"./tree-fill": 1345,
	"./tree-fill.svg": 1345,
	"./tree.svg": 1344,
	"./triangle": 1346,
	"./triangle-fill": 1347,
	"./triangle-fill.svg": 1347,
	"./triangle-half": 1348,
	"./triangle-half.svg": 1348,
	"./triangle.svg": 1346,
	"./trophy": 1349,
	"./trophy-fill": 1350,
	"./trophy-fill.svg": 1350,
	"./trophy.svg": 1349,
	"./tropical-storm": 1351,
	"./tropical-storm.svg": 1351,
	"./truck": 1352,
	"./truck-flatbed": 1353,
	"./truck-flatbed.svg": 1353,
	"./truck.svg": 1352,
	"./tsunami": 1354,
	"./tsunami.svg": 1354,
	"./tv": 1355,
	"./tv-fill": 1356,
	"./tv-fill.svg": 1356,
	"./tv.svg": 1355,
	"./twitch": 1357,
	"./twitch.svg": 1357,
	"./twitter": 1358,
	"./twitter.svg": 1358,
	"./type": 1359,
	"./type-bold": 1360,
	"./type-bold.svg": 1360,
	"./type-h1": 1361,
	"./type-h1.svg": 1361,
	"./type-h2": 1362,
	"./type-h2.svg": 1362,
	"./type-h3": 1363,
	"./type-h3.svg": 1363,
	"./type-italic": 1364,
	"./type-italic.svg": 1364,
	"./type-strikethrough": 1365,
	"./type-strikethrough.svg": 1365,
	"./type-underline": 1366,
	"./type-underline.svg": 1366,
	"./type.svg": 1359,
	"./ui-checks": 1367,
	"./ui-checks-grid": 1368,
	"./ui-checks-grid.svg": 1368,
	"./ui-checks.svg": 1367,
	"./ui-radios": 1369,
	"./ui-radios-grid": 1370,
	"./ui-radios-grid.svg": 1370,
	"./ui-radios.svg": 1369,
	"./umbrella": 1371,
	"./umbrella-fill": 1372,
	"./umbrella-fill.svg": 1372,
	"./umbrella.svg": 1371,
	"./union": 1373,
	"./union.svg": 1373,
	"./unlock": 1374,
	"./unlock-fill": 1375,
	"./unlock-fill.svg": 1375,
	"./unlock.svg": 1374,
	"./upc": 1376,
	"./upc-scan": 1377,
	"./upc-scan.svg": 1377,
	"./upc.svg": 1376,
	"./upload": 1378,
	"./upload.svg": 1378,
	"./vector-pen": 1379,
	"./vector-pen.svg": 1379,
	"./view-list": 1380,
	"./view-list.svg": 1380,
	"./view-stacked": 1381,
	"./view-stacked.svg": 1381,
	"./vinyl": 1382,
	"./vinyl-fill": 1383,
	"./vinyl-fill.svg": 1383,
	"./vinyl.svg": 1382,
	"./voicemail": 1384,
	"./voicemail.svg": 1384,
	"./volume-down": 1385,
	"./volume-down-fill": 1386,
	"./volume-down-fill.svg": 1386,
	"./volume-down.svg": 1385,
	"./volume-mute": 1387,
	"./volume-mute-fill": 1388,
	"./volume-mute-fill.svg": 1388,
	"./volume-mute.svg": 1387,
	"./volume-off": 1389,
	"./volume-off-fill": 1390,
	"./volume-off-fill.svg": 1390,
	"./volume-off.svg": 1389,
	"./volume-up": 1391,
	"./volume-up-fill": 1392,
	"./volume-up-fill.svg": 1392,
	"./volume-up.svg": 1391,
	"./vr": 1393,
	"./vr.svg": 1393,
	"./wallet": 1394,
	"./wallet-fill": 1395,
	"./wallet-fill.svg": 1395,
	"./wallet.svg": 1394,
	"./wallet2": 1396,
	"./wallet2.svg": 1396,
	"./watch": 1397,
	"./watch.svg": 1397,
	"./water": 1398,
	"./water.svg": 1398,
	"./whatsapp": 1399,
	"./whatsapp.svg": 1399,
	"./wifi": 1400,
	"./wifi-1": 1401,
	"./wifi-1.svg": 1401,
	"./wifi-2": 1402,
	"./wifi-2.svg": 1402,
	"./wifi-off": 1403,
	"./wifi-off.svg": 1403,
	"./wifi.svg": 1400,
	"./wind": 1404,
	"./wind.svg": 1404,
	"./window": 1405,
	"./window-dock": 1406,
	"./window-dock.svg": 1406,
	"./window-sidebar": 1407,
	"./window-sidebar.svg": 1407,
	"./window.svg": 1405,
	"./wrench": 1408,
	"./wrench.svg": 1408,
	"./x": 1409,
	"./x-circle": 1410,
	"./x-circle-fill": 1411,
	"./x-circle-fill.svg": 1411,
	"./x-circle.svg": 1410,
	"./x-diamond": 1412,
	"./x-diamond-fill": 1413,
	"./x-diamond-fill.svg": 1413,
	"./x-diamond.svg": 1412,
	"./x-lg": 1414,
	"./x-lg.svg": 1414,
	"./x-octagon": 1415,
	"./x-octagon-fill": 1416,
	"./x-octagon-fill.svg": 1416,
	"./x-octagon.svg": 1415,
	"./x-square": 1417,
	"./x-square-fill": 1418,
	"./x-square-fill.svg": 1418,
	"./x-square.svg": 1417,
	"./x.svg": 1409,
	"./youtube": 1419,
	"./youtube.svg": 1419,
	"./zoom-in": 1420,
	"./zoom-in.svg": 1420,
	"./zoom-out": 1421,
	"./zoom-out.svg": 1421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1684;